export const emojiData: {
  category: string;
  categoryIcon: string;
  emojis: { name: string; url: string }[];
}[] = [
  {
    category: 'buildings',
    categoryIcon: 'https://media.fatsu.com/fatsoji/categories/building.svg',
    emojis: [
      {
        name: 'apartment building',
        url: 'https://media.fatsu.com/fatsoji/buildings/Apartment Building.png',
      },
      {
        name: 'bank',
        url: 'https://media.fatsu.com/fatsoji/buildings/Bank.png',
      },
      {
        name: 'castle',
        url: 'https://media.fatsu.com/fatsoji/buildings/Castle.png',
      },
      {
        name: 'cathedral',
        url: 'https://media.fatsu.com/fatsoji/buildings/Cathedral.png',
      },
      {
        name: 'chapel',
        url: 'https://media.fatsu.com/fatsoji/buildings/Chapel.png',
      },
      {
        name: 'church',
        url: 'https://media.fatsu.com/fatsoji/buildings/Church.png',
      },
      {
        name: 'convenience store',
        url: 'https://media.fatsu.com/fatsoji/buildings/Convenience Store.png',
      },
      {
        name: 'eiffel',
        url: 'https://media.fatsu.com/fatsoji/buildings/Eiffel.png',
      },
      {
        name: 'factory with chimneys',
        url: 'https://media.fatsu.com/fatsoji/buildings/Factory with Chimneys.png',
      },
      {
        name: 'factory',
        url: 'https://media.fatsu.com/fatsoji/buildings/Factory.png',
      },
      {
        name: 'fountain',
        url: 'https://media.fatsu.com/fatsoji/buildings/Fountain.png',
      },
      {
        name: 'framed picture',
        url: 'https://media.fatsu.com/fatsoji/buildings/Framed Picture.png',
      },
      {
        name: 'hospital',
        url: 'https://media.fatsu.com/fatsoji/buildings/Hospital.png',
      },
      {
        name: 'kaaba',
        url: 'https://media.fatsu.com/fatsoji/buildings/Kaaba.png',
      },
      {
        name: 'liberty',
        url: 'https://media.fatsu.com/fatsoji/buildings/Liberty.png',
      },
      {
        name: 'office building',
        url: 'https://media.fatsu.com/fatsoji/buildings/Office Building.png',
      },
      {
        name: 'office tower',
        url: 'https://media.fatsu.com/fatsoji/buildings/Office Tower.png',
      },
      {
        name: 'pagoda',
        url: 'https://media.fatsu.com/fatsoji/buildings/Pagoda.png',
      },
      {
        name: 'palace',
        url: 'https://media.fatsu.com/fatsoji/buildings/Palace.png',
      },
      {
        name: 'schoolhouse',
        url: 'https://media.fatsu.com/fatsoji/buildings/Schoolhouse.png',
      },
      {
        name: 'taj',
        url: 'https://media.fatsu.com/fatsoji/buildings/Taj.png',
      },
      {
        name: 'tent',
        url: 'https://media.fatsu.com/fatsoji/buildings/Tent.png',
      },
      {
        name: 'torii gate',
        url: 'https://media.fatsu.com/fatsoji/buildings/Torii Gate.png',
      },
      {
        name: 'university',
        url: 'https://media.fatsu.com/fatsoji/buildings/University.png',
      },
    ],
  },
  {
    category: 'creatures',
    categoryIcon: 'https://media.fatsu.com/fatsoji/categories/creatures.svg',
    emojis: [
      {
        name: 'antsy',
        url: 'https://media.fatsu.com/fatsoji/creatures/Antsy.png',
      },
      {
        name: 'baabaa',
        url: 'https://media.fatsu.com/fatsoji/creatures/BaaBaa.png',
      },
      {
        name: 'badger',
        url: 'https://media.fatsu.com/fatsoji/creatures/Badger.png',
      },
      {
        name: 'bat',
        url: 'https://media.fatsu.com/fatsoji/creatures/Bat.png',
      },
      {
        name: 'bear face',
        url: 'https://media.fatsu.com/fatsoji/creatures/Bear Face.png',
      },
      {
        name: 'bear',
        url: 'https://media.fatsu.com/fatsoji/creatures/Bear.png',
      },
      {
        name: 'bearry',
        url: 'https://media.fatsu.com/fatsoji/creatures/Bearry.png',
      },
      {
        name: 'beetle-1',
        url: 'https://media.fatsu.com/fatsoji/creatures/Beetle-1.png',
      },
      {
        name: 'beetle',
        url: 'https://media.fatsu.com/fatsoji/creatures/Beetle.png',
      },
      {
        name: 'blossom',
        url: 'https://media.fatsu.com/fatsoji/creatures/Blossom.png',
      },
      {
        name: 'bubbles',
        url: 'https://media.fatsu.com/fatsoji/creatures/Bubbles.png',
      },
      {
        name: 'buff',
        url: 'https://media.fatsu.com/fatsoji/creatures/Buff.png',
      },
      {
        name: 'buzz',
        url: 'https://media.fatsu.com/fatsoji/creatures/Buzz.png',
      },
      {
        name: 'camel',
        url: 'https://media.fatsu.com/fatsoji/creatures/Camel.png',
      },
      {
        name: 'cat face',
        url: 'https://media.fatsu.com/fatsoji/creatures/Cat Face.png',
      },
      {
        name: 'cat-1',
        url: 'https://media.fatsu.com/fatsoji/creatures/Cat-1.png',
      },
      {
        name: 'cat',
        url: 'https://media.fatsu.com/fatsoji/creatures/Cat.png',
      },
      {
        name: 'chillie',
        url: 'https://media.fatsu.com/fatsoji/creatures/Chillie.png',
      },
      {
        name: 'chirpy',
        url: 'https://media.fatsu.com/fatsoji/creatures/Chirpy.png',
      },
      {
        name: 'cow',
        url: 'https://media.fatsu.com/fatsoji/creatures/Cow.png',
      },
      {
        name: 'crab',
        url: 'https://media.fatsu.com/fatsoji/creatures/Crab.png',
      },
      {
        name: 'cracky',
        url: 'https://media.fatsu.com/fatsoji/creatures/Cracky.png',
      },
      {
        name: 'croco',
        url: 'https://media.fatsu.com/fatsoji/creatures/Croco.png',
      },
      {
        name: 'deerly',
        url: 'https://media.fatsu.com/fatsoji/creatures/Deerly.png',
      },
      {
        name: 'dino',
        url: 'https://media.fatsu.com/fatsoji/creatures/Dino.png',
      },
      {
        name: 'dog',
        url: 'https://media.fatsu.com/fatsoji/creatures/Dog.png',
      },
      {
        name: 'draco',
        url: 'https://media.fatsu.com/fatsoji/creatures/Draco.png',
      },
      {
        name: 'ellie',
        url: 'https://media.fatsu.com/fatsoji/creatures/Ellie.png',
      },
      {
        name: 'fins',
        url: 'https://media.fatsu.com/fatsoji/creatures/Fins.png',
      },
      {
        name: 'flamewing',
        url: 'https://media.fatsu.com/fatsoji/creatures/Flamewing.png',
      },
      {
        name: 'flamingo',
        url: 'https://media.fatsu.com/fatsoji/creatures/Flamingo.png',
      },
      {
        name: 'flammy',
        url: 'https://media.fatsu.com/fatsoji/creatures/Flammy.png',
      },
      {
        name: 'flappy',
        url: 'https://media.fatsu.com/fatsoji/creatures/Flappy.png',
      },
      {
        name: 'fluffy',
        url: 'https://media.fatsu.com/fatsoji/creatures/Fluffy.png',
      },
      {
        name: 'flutter',
        url: 'https://media.fatsu.com/fatsoji/creatures/Flutter.png',
      },
      {
        name: 'fly',
        url: 'https://media.fatsu.com/fatsoji/creatures/Fly.png',
      },
      {
        name: 'fox',
        url: 'https://media.fatsu.com/fatsoji/creatures/Fox.png',
      },
      {
        name: 'foxy',
        url: 'https://media.fatsu.com/fatsoji/creatures/Foxy.png',
      },
      {
        name: 'froggy',
        url: 'https://media.fatsu.com/fatsoji/creatures/Froggy.png',
      },
      {
        name: 'gecko',
        url: 'https://media.fatsu.com/fatsoji/creatures/Gecko.png',
      },
      {
        name: 'giraffe',
        url: 'https://media.fatsu.com/fatsoji/creatures/Giraffe.png',
      },
      {
        name: 'goat',
        url: 'https://media.fatsu.com/fatsoji/creatures/Goat.png',
      },
      {
        name: 'goggles',
        url: 'https://media.fatsu.com/fatsoji/creatures/Goggles.png',
      },
      {
        name: 'gorilla',
        url: 'https://media.fatsu.com/fatsoji/creatures/Gorilla.png',
      },
      {
        name: 'grasshopper',
        url: 'https://media.fatsu.com/fatsoji/creatures/Grasshopper.png',
      },
      {
        name: 'hippo-1',
        url: 'https://media.fatsu.com/fatsoji/creatures/Hippo-1.png',
      },
      {
        name: 'hippo',
        url: 'https://media.fatsu.com/fatsoji/creatures/Hippo.png',
      },
      {
        name: 'hooty',
        url: 'https://media.fatsu.com/fatsoji/creatures/Hooty.png',
      },
      {
        name: 'hopper',
        url: 'https://media.fatsu.com/fatsoji/creatures/Hopper.png',
      },
      {
        name: 'horse',
        url: 'https://media.fatsu.com/fatsoji/creatures/Horse.png',
      },
      {
        name: 'jelly',
        url: 'https://media.fatsu.com/fatsoji/creatures/Jelly.png',
      },
      {
        name: 'kangaroo',
        url: 'https://media.fatsu.com/fatsoji/creatures/Kangaroo.png',
      },
      {
        name: 'koala',
        url: 'https://media.fatsu.com/fatsoji/creatures/Koala.png',
      },
      {
        name: 'ladybug',
        url: 'https://media.fatsu.com/fatsoji/creatures/Ladybug.png',
      },
      {
        name: 'llama',
        url: 'https://media.fatsu.com/fatsoji/creatures/Llama.png',
      },
      {
        name: 'lobster',
        url: 'https://media.fatsu.com/fatsoji/creatures/Lobster.png',
      },
      {
        name: 'lyre',
        url: 'https://media.fatsu.com/fatsoji/creatures/Lyre.png',
      },
      {
        name: 'magical',
        url: 'https://media.fatsu.com/fatsoji/creatures/Magical.png',
      },
      {
        name: 'mickey',
        url: 'https://media.fatsu.com/fatsoji/creatures/Mickey.png',
      },
      {
        name: 'monkey face',
        url: 'https://media.fatsu.com/fatsoji/creatures/Monkey Face.png',
      },
      {
        name: 'monkey-1',
        url: 'https://media.fatsu.com/fatsoji/creatures/Monkey-1.png',
      },
      {
        name: 'monkey',
        url: 'https://media.fatsu.com/fatsoji/creatures/Monkey.png',
      },
      {
        name: 'moomoo',
        url: 'https://media.fatsu.com/fatsoji/creatures/MooMoo.png',
      },
      {
        name: 'mosquito',
        url: 'https://media.fatsu.com/fatsoji/creatures/Mosquito.png',
      },
      {
        name: 'nutty',
        url: 'https://media.fatsu.com/fatsoji/creatures/Nutty.png',
      },
      {
        name: 'octy',
        url: 'https://media.fatsu.com/fatsoji/creatures/Octy.png',
      },
      {
        name: 'packy',
        url: 'https://media.fatsu.com/fatsoji/creatures/Packy.png',
      },
      {
        name: 'panda',
        url: 'https://media.fatsu.com/fatsoji/creatures/Panda.png',
      },
      {
        name: 'paw prints',
        url: 'https://media.fatsu.com/fatsoji/creatures/Paw Prints.png',
      },
      {
        name: 'peacock',
        url: 'https://media.fatsu.com/fatsoji/creatures/Peacock.png',
      },
      {
        name: 'peck',
        url: 'https://media.fatsu.com/fatsoji/creatures/Peck.png',
      },
      {
        name: 'petals',
        url: 'https://media.fatsu.com/fatsoji/creatures/Petals.png',
      },
      {
        name: 'pig',
        url: 'https://media.fatsu.com/fatsoji/creatures/Pig.png',
      },
      {
        name: 'piggy',
        url: 'https://media.fatsu.com/fatsoji/creatures/Piggy.png',
      },
      {
        name: 'piglet',
        url: 'https://media.fatsu.com/fatsoji/creatures/Piglet.png',
      },
      {
        name: 'pinky-1',
        url: 'https://media.fatsu.com/fatsoji/creatures/Pinky-1.png',
      },
      {
        name: 'pinky-2',
        url: 'https://media.fatsu.com/fatsoji/creatures/Pinky-2.png',
      },
      {
        name: 'pinky',
        url: 'https://media.fatsu.com/fatsoji/creatures/Pinky.png',
      },
      {
        name: 'pony',
        url: 'https://media.fatsu.com/fatsoji/creatures/Pony.png',
      },
      {
        name: 'poppy',
        url: 'https://media.fatsu.com/fatsoji/creatures/Poppy.png',
      },
      {
        name: 'porky',
        url: 'https://media.fatsu.com/fatsoji/creatures/Porky.png',
      },
      {
        name: 'quacky',
        url: 'https://media.fatsu.com/fatsoji/creatures/Quacky.png',
      },
      {
        name: 'quill',
        url: 'https://media.fatsu.com/fatsoji/creatures/Quill.png',
      },
      {
        name: 'raccoon',
        url: 'https://media.fatsu.com/fatsoji/creatures/Raccoon.png',
      },
      {
        name: 'raven',
        url: 'https://media.fatsu.com/fatsoji/creatures/Raven.png',
      },
      {
        name: 'rexy',
        url: 'https://media.fatsu.com/fatsoji/creatures/Rexy.png',
      },
      {
        name: 'rooster',
        url: 'https://media.fatsu.com/fatsoji/creatures/Rooster.png',
      },
      {
        name: 'scorpion',
        url: 'https://media.fatsu.com/fatsoji/creatures/Scorpion.png',
      },
      {
        name: 'shelly-1',
        url: 'https://media.fatsu.com/fatsoji/creatures/Shelly-1.png',
      },
      {
        name: 'shelly',
        url: 'https://media.fatsu.com/fatsoji/creatures/Shelly.png',
      },
      {
        name: 'skunk',
        url: 'https://media.fatsu.com/fatsoji/creatures/Skunk.png',
      },
      {
        name: 'slither',
        url: 'https://media.fatsu.com/fatsoji/creatures/Slither.png',
      },
      {
        name: 'sloth',
        url: 'https://media.fatsu.com/fatsoji/creatures/Sloth.png',
      },
      {
        name: 'slowy',
        url: 'https://media.fatsu.com/fatsoji/creatures/Slowy.png',
      },
      {
        name: 'smiley',
        url: 'https://media.fatsu.com/fatsoji/creatures/Smiley.png',
      },
      {
        name: 'snake',
        url: 'https://media.fatsu.com/fatsoji/creatures/Snake.png',
      },
      {
        name: 'spark',
        url: 'https://media.fatsu.com/fatsoji/creatures/Spark.png',
      },
      {
        name: 'sparkle-1',
        url: 'https://media.fatsu.com/fatsoji/creatures/Sparkle-1.png',
      },
      {
        name: 'sparkle',
        url: 'https://media.fatsu.com/fatsoji/creatures/Sparkle.png',
      },
      {
        name: 'spider web',
        url: 'https://media.fatsu.com/fatsoji/creatures/Spider Web.png',
      },
      {
        name: 'spider',
        url: 'https://media.fatsu.com/fatsoji/creatures/Spider.png',
      },
      {
        name: 'splash',
        url: 'https://media.fatsu.com/fatsoji/creatures/Splash.png',
      },
      {
        name: 'squeaky',
        url: 'https://media.fatsu.com/fatsoji/creatures/Squeaky.png',
      },
      {
        name: 'stripey',
        url: 'https://media.fatsu.com/fatsoji/creatures/Stripey.png',
      },
      {
        name: 'stripy',
        url: 'https://media.fatsu.com/fatsoji/creatures/Stripy.png',
      },
      {
        name: 'swanny',
        url: 'https://media.fatsu.com/fatsoji/creatures/Swanny.png',
      },
      {
        name: 'swishy',
        url: 'https://media.fatsu.com/fatsoji/creatures/Swishy.png',
      },
      {
        name: 'teddy',
        url: 'https://media.fatsu.com/fatsoji/creatures/Teddy.png',
      },
      {
        name: 'tiger',
        url: 'https://media.fatsu.com/fatsoji/creatures/Tiger.png',
      },
      {
        name: 'turkey',
        url: 'https://media.fatsu.com/fatsoji/creatures/Turkey.png',
      },
      {
        name: 'tweety',
        url: 'https://media.fatsu.com/fatsoji/creatures/Tweety.png',
      },
      {
        name: 'two-hump camel',
        url: 'https://media.fatsu.com/fatsoji/creatures/Two-Hump Camel.png',
      },
      {
        name: 'unicorn-1',
        url: 'https://media.fatsu.com/fatsoji/creatures/Unicorn-1.png',
      },
      {
        name: 'unicorn',
        url: 'https://media.fatsu.com/fatsoji/creatures/Unicorn.png',
      },
      {
        name: 'virus',
        url: 'https://media.fatsu.com/fatsoji/creatures/Virus.png',
      },
      {
        name: 'waddles',
        url: 'https://media.fatsu.com/fatsoji/creatures/Waddles.png',
      },
      {
        name: 'wally-1',
        url: 'https://media.fatsu.com/fatsoji/creatures/Wally-1.png',
      },
      {
        name: 'wally',
        url: 'https://media.fatsu.com/fatsoji/creatures/Wally.png',
      },
      {
        name: 'wiggles',
        url: 'https://media.fatsu.com/fatsoji/creatures/Wiggles.png',
      },
      {
        name: 'woolly',
        url: 'https://media.fatsu.com/fatsoji/creatures/Woolly.png',
      },
      {
        name: 'worm',
        url: 'https://media.fatsu.com/fatsoji/creatures/Worm.png',
      },
    ],
  },
  {
    category: 'fashion',
    categoryIcon: 'https://media.fatsu.com/fatsoji/categories/fashion.svg',
    emojis: [
      {
        name: 'ankle boots',
        url: 'https://media.fatsu.com/fatsoji/fashion/Ankle Boots.png',
      },
      {
        name: 'backpack',
        url: 'https://media.fatsu.com/fatsoji/fashion/Backpack.png',
      },
      {
        name: 'bag with handle',
        url: 'https://media.fatsu.com/fatsoji/fashion/Bag with Handle.png',
      },
      {
        name: 'ballet shoes',
        url: 'https://media.fatsu.com/fatsoji/fashion/Ballet Shoes.png',
      },
      {
        name: 'beats',
        url: 'https://media.fatsu.com/fatsoji/fashion/Beats.png',
      },
      {
        name: 'belt',
        url: 'https://media.fatsu.com/fatsoji/fashion/Belt.png',
      },
      {
        name: 'biting lips',
        url: 'https://media.fatsu.com/fatsoji/fashion/Biting Lips.png',
      },
      {
        name: 'block heel',
        url: 'https://media.fatsu.com/fatsoji/fashion/Block Heel.png',
      },
      {
        name: 'blue jacket',
        url: 'https://media.fatsu.com/fatsoji/fashion/Blue Jacket.png',
      },
      {
        name: 'blue mustache',
        url: 'https://media.fatsu.com/fatsoji/fashion/Blue Mustache.png',
      },
      {
        name: 'blue ribbon bow',
        url: 'https://media.fatsu.com/fatsoji/fashion/Blue Ribbon Bow.png',
      },
      {
        name: 'boots',
        url: 'https://media.fatsu.com/fatsoji/fashion/Boots.png',
      },
      {
        name: 'bow tie',
        url: 'https://media.fatsu.com/fatsoji/fashion/Bow Tie.png',
      },
      {
        name: 'bowler hat',
        url: 'https://media.fatsu.com/fatsoji/fashion/Bowler Hat.png',
      },
      {
        name: 'briefcase',
        url: 'https://media.fatsu.com/fatsoji/fashion/Briefcase.png',
      },
      {
        name: 'brown mustache',
        url: 'https://media.fatsu.com/fatsoji/fashion/Brown Mustache.png',
      },
      {
        name: 'chic phone',
        url: 'https://media.fatsu.com/fatsoji/fashion/Chic Phone.png',
      },
      {
        name: 'clapping hands',
        url: 'https://media.fatsu.com/fatsoji/fashion/Clapping Hands.png',
      },
      {
        name: 'click',
        url: 'https://media.fatsu.com/fatsoji/fashion/Click.png',
      },
      {
        name: 'clutch         high heels',
        url: 'https://media.fatsu.com/fatsoji/fashion/Clutch         High Heels.png',
      },
      {
        name: 'clutch',
        url: 'https://media.fatsu.com/fatsoji/fashion/Clutch.png',
      },
      {
        name: 'coat',
        url: 'https://media.fatsu.com/fatsoji/fashion/Coat.png',
      },
      {
        name: 'cream jar',
        url: 'https://media.fatsu.com/fatsoji/fashion/Cream Jar.png',
      },
      {
        name: 'crown',
        url: 'https://media.fatsu.com/fatsoji/fashion/Crown.png',
      },
      {
        name: 'curled mustache',
        url: 'https://media.fatsu.com/fatsoji/fashion/Curled Mustache.png',
      },
      {
        name: 'curly afro',
        url: 'https://media.fatsu.com/fatsoji/fashion/Curly Afro.png',
      },
      {
        name: 'curly hair',
        url: 'https://media.fatsu.com/fatsoji/fashion/Curly Hair.png',
      },
      {
        name: 'dark blue tie',
        url: 'https://media.fatsu.com/fatsoji/fashion/Dark Blue Tie.png',
      },
      {
        name: 'dressy',
        url: 'https://media.fatsu.com/fatsoji/fashion/Dressy.png',
      },
      {
        name: 'earphones',
        url: 'https://media.fatsu.com/fatsoji/fashion/Earphones.png',
      },
      {
        name: 'eye',
        url: 'https://media.fatsu.com/fatsoji/fashion/Eye.png',
      },
      {
        name: 'eyeglasses',
        url: 'https://media.fatsu.com/fatsoji/fashion/Eyeglasses.png',
      },
      {
        name: 'eyelash',
        url: 'https://media.fatsu.com/fatsoji/fashion/Eyelash.png',
      },
      {
        name: 'eyeshadow palette',
        url: 'https://media.fatsu.com/fatsoji/fashion/Eyeshadow Palette.png',
      },
      {
        name: 'fedora hat',
        url: 'https://media.fatsu.com/fatsoji/fashion/Fedora Hat.png',
      },
      {
        name: 'flat shoes',
        url: 'https://media.fatsu.com/fatsoji/fashion/Flat Shoes.png',
      },
      {
        name: 'flip-flops',
        url: 'https://media.fatsu.com/fatsoji/fashion/Flip-Flops.png',
      },
      {
        name: 'fringe with waves',
        url: 'https://media.fatsu.com/fatsoji/fashion/Fringe with Waves.png',
      },
      {
        name: 'glam heel',
        url: 'https://media.fatsu.com/fatsoji/fashion/Glam Heel.png',
      },
      {
        name: 'glasses',
        url: 'https://media.fatsu.com/fatsoji/fashion/Glasses.png',
      },
      {
        name: 'glove',
        url: 'https://media.fatsu.com/fatsoji/fashion/Glove.png',
      },
      {
        name: 'goggles',
        url: 'https://media.fatsu.com/fatsoji/fashion/Goggles.png',
      },
      {
        name: 'graduation cap',
        url: 'https://media.fatsu.com/fatsoji/fashion/Graduation Cap.png',
      },
      {
        name: 'handbag',
        url: 'https://media.fatsu.com/fatsoji/fashion/Handbag.png',
      },
      {
        name: 'handlebar mustache',
        url: 'https://media.fatsu.com/fatsoji/fashion/Handlebar Mustache.png',
      },
      {
        name: 'handshake',
        url: 'https://media.fatsu.com/fatsoji/fashion/Handshake.png',
      },
      {
        name: 'jacket',
        url: 'https://media.fatsu.com/fatsoji/fashion/Jacket.png',
      },
      {
        name: 'kissing lips',
        url: 'https://media.fatsu.com/fatsoji/fashion/Kissing Lips.png',
      },
      {
        name: 'layered bob',
        url: 'https://media.fatsu.com/fatsoji/fashion/Layered Bob.png',
      },
      {
        name: 'light blue tie',
        url: 'https://media.fatsu.com/fatsoji/fashion/Light Blue Tie.png',
      },
      {
        name: 'lipstick',
        url: 'https://media.fatsu.com/fatsoji/fashion/Lipstick.png',
      },
      {
        name: 'loafers',
        url: 'https://media.fatsu.com/fatsoji/fashion/Loafers.png',
      },
      {
        name: 'loose waves',
        url: 'https://media.fatsu.com/fatsoji/fashion/Loose Waves.png',
      },
      {
        name: 'lotion tube',
        url: 'https://media.fatsu.com/fatsoji/fashion/Lotion Tube.png',
      },
      {
        name: 'makeup compact',
        url: 'https://media.fatsu.com/fatsoji/fashion/Makeup Compact.png',
      },
      {
        name: 'manicure',
        url: 'https://media.fatsu.com/fatsoji/fashion/Manicure.png',
      },
      {
        name: 'mascara',
        url: 'https://media.fatsu.com/fatsoji/fashion/Mascara.png',
      },
      {
        name: 'mustache',
        url: 'https://media.fatsu.com/fatsoji/fashion/Mustache.png',
      },
      {
        name: 'nail polish-1',
        url: 'https://media.fatsu.com/fatsoji/fashion/Nail Polish-1.png',
      },
      {
        name: 'nail polish',
        url: 'https://media.fatsu.com/fatsoji/fashion/Nail Polish.png',
      },
      {
        name: 'necklace',
        url: 'https://media.fatsu.com/fatsoji/fashion/Necklace.png',
      },
      {
        name: 'onesie',
        url: 'https://media.fatsu.com/fatsoji/fashion/Onesie.png',
      },
      {
        name: 'open lips',
        url: 'https://media.fatsu.com/fatsoji/fashion/Open Lips.png',
      },
      {
        name: 'painted nails (dark skin)',
        url: 'https://media.fatsu.com/fatsoji/fashion/Painted Nails (Dark Skin).png',
      },
      {
        name: 'painted nails (light skin)',
        url: 'https://media.fatsu.com/fatsoji/fashion/Painted Nails (Light Skin).png',
      },
      {
        name: 'pants',
        url: 'https://media.fatsu.com/fatsoji/fashion/Pants.png',
      },
      {
        name: 'patterned tie',
        url: 'https://media.fatsu.com/fatsoji/fashion/Patterned Tie.png',
      },
      {
        name: 'pink purse',
        url: 'https://media.fatsu.com/fatsoji/fashion/Pink Purse.png',
      },
      {
        name: 'polka dot bow tie',
        url: 'https://media.fatsu.com/fatsoji/fashion/Polka Dot Bow Tie.png',
      },
      {
        name: 'pursed lips',
        url: 'https://media.fatsu.com/fatsoji/fashion/Pursed Lips.png',
      },
      {
        name: 'safety vest',
        url: 'https://media.fatsu.com/fatsoji/fashion/Safety Vest.png',
      },
      {
        name: 'scarf-1',
        url: 'https://media.fatsu.com/fatsoji/fashion/Scarf-1.png',
      },
      {
        name: 'scarf',
        url: 'https://media.fatsu.com/fatsoji/fashion/Scarf.png',
      },
      {
        name: 'scooter',
        url: 'https://media.fatsu.com/fatsoji/fashion/Scooter.png',
      },
      {
        name: 'selfie',
        url: 'https://media.fatsu.com/fatsoji/fashion/Selfie.png',
      },
      {
        name: 'shades',
        url: 'https://media.fatsu.com/fatsoji/fashion/Shades.png',
      },
      {
        name: 'shiny gem',
        url: 'https://media.fatsu.com/fatsoji/fashion/Shiny Gem.png',
      },
      {
        name: 'shirt',
        url: 'https://media.fatsu.com/fatsoji/fashion/Shirt.png',
      },
      {
        name: 'shopping bag',
        url: 'https://media.fatsu.com/fatsoji/fashion/Shopping Bag.png',
      },
      {
        name: 'shorts',
        url: 'https://media.fatsu.com/fatsoji/fashion/Shorts.png',
      },
      {
        name: 'shoulder-length curls',
        url: 'https://media.fatsu.com/fatsoji/fashion/Shoulder-Length Curls.png',
      },
      {
        name: 'side-part bob',
        url: 'https://media.fatsu.com/fatsoji/fashion/Side-Part Bob.png',
      },
      {
        name: 'side-swept curls',
        url: 'https://media.fatsu.com/fatsoji/fashion/Side-Swept Curls.png',
      },
      {
        name: 'sleep mask',
        url: 'https://media.fatsu.com/fatsoji/fashion/Sleep Mask.png',
      },
      {
        name: 'small blue mustache',
        url: 'https://media.fatsu.com/fatsoji/fashion/Small Blue Mustache.png',
      },
      {
        name: 'smiling lips',
        url: 'https://media.fatsu.com/fatsoji/fashion/Smiling Lips.png',
      },
      {
        name: 'sneakers',
        url: 'https://media.fatsu.com/fatsoji/fashion/Sneakers.png',
      },
      {
        name: 'socks',
        url: 'https://media.fatsu.com/fatsoji/fashion/Socks.png',
      },
      {
        name: 'starry sparkle',
        url: 'https://media.fatsu.com/fatsoji/fashion/Starry Sparkle.png',
      },
      {
        name: 'straight bob',
        url: 'https://media.fatsu.com/fatsoji/fashion/Straight Bob.png',
      },
      {
        name: 'striped bow tie',
        url: 'https://media.fatsu.com/fatsoji/fashion/Striped Bow Tie.png',
      },
      {
        name: 'sun hat',
        url: 'https://media.fatsu.com/fatsoji/fashion/Sun Hat.png',
      },
      {
        name: 'sunglasses-1',
        url: 'https://media.fatsu.com/fatsoji/fashion/Sunglasses-1.png',
      },
      {
        name: 'sunglasses',
        url: 'https://media.fatsu.com/fatsoji/fashion/Sunglasses.png',
      },
      {
        name: 'sweater',
        url: 'https://media.fatsu.com/fatsoji/fashion/Sweater.png',
      },
      {
        name: 'swimsuit',
        url: 'https://media.fatsu.com/fatsoji/fashion/Swimsuit.png',
      },
      {
        name: 't-shirt',
        url: 'https://media.fatsu.com/fatsoji/fashion/T-Shirt.png',
      },
      {
        name: 'tight curls',
        url: 'https://media.fatsu.com/fatsoji/fashion/Tight Curls.png',
      },
      {
        name: 'timely watch',
        url: 'https://media.fatsu.com/fatsoji/fashion/Timely Watch.png',
      },
      {
        name: 'top hat-1',
        url: 'https://media.fatsu.com/fatsoji/fashion/Top Hat-1.png',
      },
      {
        name: 'top hat',
        url: 'https://media.fatsu.com/fatsoji/fashion/Top Hat.png',
      },
      {
        name: 'umbrella',
        url: 'https://media.fatsu.com/fatsoji/fashion/Umbrella.png',
      },
      {
        name: 'underwear',
        url: 'https://media.fatsu.com/fatsoji/fashion/Underwear.png',
      },
      {
        name: 'wig',
        url: 'https://media.fatsu.com/fatsoji/fashion/Wig.png',
      },
    ],
  },
  {
    category: 'festive',
    categoryIcon: 'https://media.fatsu.com/fatsoji/categories/festive.svg',
    emojis: [
      {
        name: 'balloon',
        url: 'https://media.fatsu.com/fatsoji/festive/Balloon.png',
      },
      {
        name: 'barber pole',
        url: 'https://media.fatsu.com/fatsoji/festive/Barber Pole.png',
      },
      {
        name: 'birthday cake',
        url: 'https://media.fatsu.com/fatsoji/festive/Birthday Cake.png',
      },
      {
        name: 'bonfire',
        url: 'https://media.fatsu.com/fatsoji/festive/Bonfire.png',
      },
      {
        name: 'bride and groom',
        url: 'https://media.fatsu.com/fatsoji/festive/Bride and Groom.png',
      },
      {
        name: 'carousel horse',
        url: 'https://media.fatsu.com/fatsoji/festive/Carousel Horse.png',
      },
      {
        name: 'christmas tree',
        url: 'https://media.fatsu.com/fatsoji/festive/Christmas Tree.png',
      },
      {
        name: 'circus tent',
        url: 'https://media.fatsu.com/fatsoji/festive/Circus Tent.png',
      },
      {
        name: 'confetti burst',
        url: 'https://media.fatsu.com/fatsoji/festive/Confetti Burst.png',
      },
      {
        name: 'cozy decor',
        url: 'https://media.fatsu.com/fatsoji/festive/Cozy Decor.png',
      },
      {
        name: 'crescent moon',
        url: 'https://media.fatsu.com/fatsoji/festive/Crescent Moon.png',
      },
      {
        name: 'decorative lamp',
        url: 'https://media.fatsu.com/fatsoji/festive/Decorative Lamp.png',
      },
      {
        name: 'drum',
        url: 'https://media.fatsu.com/fatsoji/festive/Drum.png',
      },
      {
        name: 'envelope',
        url: 'https://media.fatsu.com/fatsoji/festive/Envelope.png',
      },
      {
        name: 'ferris wheel',
        url: 'https://media.fatsu.com/fatsoji/festive/Ferris Wheel.png',
      },
      {
        name: 'firecracker',
        url: 'https://media.fatsu.com/fatsoji/festive/Firecracker.png',
      },
      {
        name: 'fireworks box',
        url: 'https://media.fatsu.com/fatsoji/festive/Fireworks Box.png',
      },
      {
        name: 'gift box',
        url: 'https://media.fatsu.com/fatsoji/festive/Gift Box.png',
      },
      {
        name: 'gift',
        url: 'https://media.fatsu.com/fatsoji/festive/Gift.png',
      },
      {
        name: 'guitar',
        url: 'https://media.fatsu.com/fatsoji/festive/Guitar.png',
      },
      {
        name: "jack-o'-lantern",
        url: "https://media.fatsu.com/fatsoji/festive/Jack-O'-Lantern.png",
      },
      {
        name: 'log fire',
        url: 'https://media.fatsu.com/fatsoji/festive/Log Fire.png',
      },
      {
        name: 'lollipop',
        url: 'https://media.fatsu.com/fatsoji/festive/Lollipop.png',
      },
      {
        name: 'magic wand',
        url: 'https://media.fatsu.com/fatsoji/festive/Magic Wand.png',
      },
      {
        name: 'party cone',
        url: 'https://media.fatsu.com/fatsoji/festive/Party Cone.png',
      },
      {
        name: 'piano',
        url: 'https://media.fatsu.com/fatsoji/festive/Piano.png',
      },
      {
        name: 'ribbon',
        url: 'https://media.fatsu.com/fatsoji/festive/Ribbon.png',
      },
      {
        name: 'roller coaster',
        url: 'https://media.fatsu.com/fatsoji/festive/Roller Coaster.png',
      },
      {
        name: 'snowman pair',
        url: 'https://media.fatsu.com/fatsoji/festive/Snowman Pair.png',
      },
      {
        name: 'sparkler',
        url: 'https://media.fatsu.com/fatsoji/festive/Sparkler.png',
      },
      {
        name: 'sunburst',
        url: 'https://media.fatsu.com/fatsoji/festive/Sunburst.png',
      },
      {
        name: 'trumpet',
        url: 'https://media.fatsu.com/fatsoji/festive/Trumpet.png',
      },
      {
        name: 'violin',
        url: 'https://media.fatsu.com/fatsoji/festive/Violin.png',
      },
      {
        name: 'wrapped candies',
        url: 'https://media.fatsu.com/fatsoji/festive/Wrapped Candies.png',
      },
    ],
  },
  {
    categoryIcon: 'https://media.fatsu.com/fatsoji/categories/flags.svg',
    category: 'flags',
    emojis: [
      {
        name: 'afghanistan',
        url: 'https://media.fatsu.com/fatsoji/flags/Afghanistan.png',
      },
      {
        name: 'albania',
        url: 'https://media.fatsu.com/fatsoji/flags/Albania.png',
      },
      {
        name: 'algeria',
        url: 'https://media.fatsu.com/fatsoji/flags/Algeria.png',
      },
      {
        name: 'andorra',
        url: 'https://media.fatsu.com/fatsoji/flags/Andorra.png',
      },
      {
        name: 'angola',
        url: 'https://media.fatsu.com/fatsoji/flags/Angola.png',
      },
      {
        name: 'antigua and barbuda',
        url: 'https://media.fatsu.com/fatsoji/flags/Antigua and Barbuda.png',
      },
      {
        name: 'argentina',
        url: 'https://media.fatsu.com/fatsoji/flags/Argentina.png',
      },
      {
        name: 'armenia',
        url: 'https://media.fatsu.com/fatsoji/flags/Armenia.png',
      },
      {
        name: 'australia',
        url: 'https://media.fatsu.com/fatsoji/flags/Australia.png',
      },
      {
        name: 'austria',
        url: 'https://media.fatsu.com/fatsoji/flags/Austria.png',
      },
      {
        name: 'azerbaijan',
        url: 'https://media.fatsu.com/fatsoji/flags/Azerbaijan.png',
      },
      {
        name: 'bahamas',
        url: 'https://media.fatsu.com/fatsoji/flags/Bahamas.png',
      },
      {
        name: 'bahrain',
        url: 'https://media.fatsu.com/fatsoji/flags/Bahrain.png',
      },
      {
        name: 'barbados',
        url: 'https://media.fatsu.com/fatsoji/flags/Barbados.png',
      },
      {
        name: 'belarus',
        url: 'https://media.fatsu.com/fatsoji/flags/Belarus.png',
      },
      {
        name: 'belgium-1',
        url: 'https://media.fatsu.com/fatsoji/flags/Belgium-1.png',
      },
      {
        name: 'belgium',
        url: 'https://media.fatsu.com/fatsoji/flags/Belgium.png',
      },
      {
        name: 'belize',
        url: 'https://media.fatsu.com/fatsoji/flags/Belize.png',
      },
      {
        name: 'benin',
        url: 'https://media.fatsu.com/fatsoji/flags/Benin.png',
      },
      {
        name: 'bhutan',
        url: 'https://media.fatsu.com/fatsoji/flags/Bhutan.png',
      },
      {
        name: 'bolivia',
        url: 'https://media.fatsu.com/fatsoji/flags/Bolivia.png',
      },
      {
        name: 'bosnia and herzegovina',
        url: 'https://media.fatsu.com/fatsoji/flags/Bosnia%20and%20Herzegovina.png',
      },
      {
        name: 'brazil',
        url: 'https://media.fatsu.com/fatsoji/flags/Brazil.png',
      },
      {
        name: 'brunei',
        url: 'https://media.fatsu.com/fatsoji/flags/Brunei.png',
      },
      {
        name: 'bulgaria',
        url: 'https://media.fatsu.com/fatsoji/flags/Bulgaria.png',
      },
      {
        name: 'burkina faso',
        url: 'https://media.fatsu.com/fatsoji/flags/Burkina Faso.png',
      },
      {
        name: 'burundi',
        url: 'https://media.fatsu.com/fatsoji/flags/Burundi.png',
      },
      {
        name: 'cambodia',
        url: 'https://media.fatsu.com/fatsoji/flags/Cambodia.png',
      },
      {
        name: 'cameroon',
        url: 'https://media.fatsu.com/fatsoji/flags/Cameroon.png',
      },
      {
        name: 'canada',
        url: 'https://media.fatsu.com/fatsoji/flags/Canada.png',
      },
      {
        name: 'cape verde',
        url: 'https://media.fatsu.com/fatsoji/flags/Cape Verde.png',
      },
      {
        name: 'central african republic',
        url: 'https://media.fatsu.com/fatsoji/flags/Central African Republic.png',
      },
      {
        name: 'chile',
        url: 'https://media.fatsu.com/fatsoji/flags/Chile.png',
      },
      {
        name: 'china',
        url: 'https://media.fatsu.com/fatsoji/flags/China.png',
      },
      {
        name: 'colombia',
        url: 'https://media.fatsu.com/fatsoji/flags/Colombia.png',
      },
      {
        name: 'comoros',
        url: 'https://media.fatsu.com/fatsoji/flags/Comoros.png',
      },
      {
        name: 'côte d’ivoire (ivory coast)',
        url: 'https://media.fatsu.com/fatsoji/flags/Côte d’Ivoire (Ivory Coast).png',
      },
      {
        name: 'croatia',
        url: 'https://media.fatsu.com/fatsoji/flags/Croatia.png',
      },
      {
        name: 'cuba',
        url: 'https://media.fatsu.com/fatsoji/flags/Cuba.png',
      },
      {
        name: 'czech republic',
        url: 'https://media.fatsu.com/fatsoji/flags/Czech Republic.png',
      },
      {
        name: 'democratic republic of the congo',
        url: 'https://media.fatsu.com/fatsoji/flags/Democratic Republic of the Congo.png',
      },
      {
        name: 'denmark',
        url: 'https://media.fatsu.com/fatsoji/flags/Denmark.png',
      },
      {
        name: 'djibouti',
        url: 'https://media.fatsu.com/fatsoji/flags/Djibouti.png',
      },
      {
        name: 'dominica',
        url: 'https://media.fatsu.com/fatsoji/flags/Dominica.png',
      },
      {
        name: 'dominican republic',
        url: 'https://media.fatsu.com/fatsoji/flags/Dominican Republic.png',
      },
      {
        name: 'egypt',
        url: 'https://media.fatsu.com/fatsoji/flags/Egypt.png',
      },
      {
        name: 'equatorial guinea',
        url: 'https://media.fatsu.com/fatsoji/flags/Equatorial Guinea.png',
      },
      {
        name: 'eritrea',
        url: 'https://media.fatsu.com/fatsoji/flags/Eritrea.png',
      },
      {
        name: 'estonia',
        url: 'https://media.fatsu.com/fatsoji/flags/Estonia.png',
      },
      {
        name: 'eswatini',
        url: 'https://media.fatsu.com/fatsoji/flags/Eswatini.png',
      },
      {
        name: 'ethiopia',
        url: 'https://media.fatsu.com/fatsoji/flags/Ethiopia.png',
      },
      {
        name: 'fiji',
        url: 'https://media.fatsu.com/fatsoji/flags/Fiji.png',
      },
      {
        name: 'finland',
        url: 'https://media.fatsu.com/fatsoji/flags/Finland.png',
      },
      {
        name: 'france',
        url: 'https://media.fatsu.com/fatsoji/flags/France.png',
      },
      {
        name: 'gabon',
        url: 'https://media.fatsu.com/fatsoji/flags/Gabon.png',
      },
      {
        name: 'georgia',
        url: 'https://media.fatsu.com/fatsoji/flags/Georgia.png',
      },
      {
        name: 'germany',
        url: 'https://media.fatsu.com/fatsoji/flags/Germany.png',
      },
      {
        name: 'ghana',
        url: 'https://media.fatsu.com/fatsoji/flags/Ghana.png',
      },
      {
        name: 'greece',
        url: 'https://media.fatsu.com/fatsoji/flags/Greece.png',
      },
      {
        name: 'grenada',
        url: 'https://media.fatsu.com/fatsoji/flags/Grenada.png',
      },
      {
        name: 'guatemala',
        url: 'https://media.fatsu.com/fatsoji/flags/Guatemala.png',
      },
      {
        name: 'guinea-bissau-1',
        url: 'https://media.fatsu.com/fatsoji/flags/Guinea-Bissau-1.png',
      },
      {
        name: 'guinea-bissau',
        url: 'https://media.fatsu.com/fatsoji/flags/Guinea-Bissau.png',
      },
      {
        name: 'guyana',
        url: 'https://media.fatsu.com/fatsoji/flags/Guyana.png',
      },
      {
        name: 'haiti',
        url: 'https://media.fatsu.com/fatsoji/flags/Haiti.png',
      },
      {
        name: 'honduras',
        url: 'https://media.fatsu.com/fatsoji/flags/Honduras.png',
      },
      {
        name: 'hungary',
        url: 'https://media.fatsu.com/fatsoji/flags/Hungary.png',
      },
      {
        name: 'iceland',
        url: 'https://media.fatsu.com/fatsoji/flags/Iceland.png',
      },
      {
        name: 'india',
        url: 'https://media.fatsu.com/fatsoji/flags/India.png',
      },
      {
        name: 'indonesia-1',
        url: 'https://media.fatsu.com/fatsoji/flags/Indonesia-1.png',
      },
      {
        name: 'indonesia',
        url: 'https://media.fatsu.com/fatsoji/flags/Indonesia.png',
      },
      {
        name: 'iran',
        url: 'https://media.fatsu.com/fatsoji/flags/Iran.png',
      },
      {
        name: 'iraq',
        url: 'https://media.fatsu.com/fatsoji/flags/Iraq.png',
      },
      {
        name: 'ireland-1',
        url: 'https://media.fatsu.com/fatsoji/flags/Ireland-1.png',
      },
      {
        name: 'ireland',
        url: 'https://media.fatsu.com/fatsoji/flags/Ireland.png',
      },
      {
        name: 'italy',
        url: 'https://media.fatsu.com/fatsoji/flags/Italy.png',
      },
      {
        name: 'jamaica',
        url: 'https://media.fatsu.com/fatsoji/flags/Jamaica.png',
      },
      {
        name: 'japan',
        url: 'https://media.fatsu.com/fatsoji/flags/Japan.png',
      },
      {
        name: 'jordan',
        url: 'https://media.fatsu.com/fatsoji/flags/Jordan.png',
      },
      {
        name: 'kazakhstan',
        url: 'https://media.fatsu.com/fatsoji/flags/Kazakhstan.png',
      },
      {
        name: 'kenya',
        url: 'https://media.fatsu.com/fatsoji/flags/Kenya.png',
      },
      {
        name: 'kiribati',
        url: 'https://media.fatsu.com/fatsoji/flags/Kiribati.png',
      },
      {
        name: 'kuwait',
        url: 'https://media.fatsu.com/fatsoji/flags/Kuwait.png',
      },
      {
        name: 'kyrgyzstan',
        url: 'https://media.fatsu.com/fatsoji/flags/Kyrgyzstan.png',
      },
      {
        name: 'laos',
        url: 'https://media.fatsu.com/fatsoji/flags/Laos.png',
      },
      {
        name: 'latvia',
        url: 'https://media.fatsu.com/fatsoji/flags/Latvia.png',
      },
      {
        name: 'lebanon',
        url: 'https://media.fatsu.com/fatsoji/flags/Lebanon.png',
      },
      {
        name: 'lesotho',
        url: 'https://media.fatsu.com/fatsoji/flags/Lesotho.png',
      },
      {
        name: 'liberia',
        url: 'https://media.fatsu.com/fatsoji/flags/Liberia.png',
      },
      {
        name: 'libya',
        url: 'https://media.fatsu.com/fatsoji/flags/Libya.png',
      },
      {
        name: 'liechtenstein',
        url: 'https://media.fatsu.com/fatsoji/flags/Liechtenstein.png',
      },
      {
        name: 'lithuania',
        url: 'https://media.fatsu.com/fatsoji/flags/Lithuania.png',
      },
      {
        name: 'luxembourg',
        url: 'https://media.fatsu.com/fatsoji/flags/Luxembourg.png',
      },
      {
        name: 'madagascar',
        url: 'https://media.fatsu.com/fatsoji/flags/Madagascar.png',
      },
      {
        name: 'malawi',
        url: 'https://media.fatsu.com/fatsoji/flags/Malawi.png',
      },
      {
        name: 'malaysia',
        url: 'https://media.fatsu.com/fatsoji/flags/Malaysia.png',
      },
      {
        name: 'maldives',
        url: 'https://media.fatsu.com/fatsoji/flags/Maldives.png',
      },
      {
        name: 'mali',
        url: 'https://media.fatsu.com/fatsoji/flags/Mali.png',
      },
      {
        name: 'malta',
        url: 'https://media.fatsu.com/fatsoji/flags/Malta.png',
      },
      {
        name: 'marshall islands',
        url: 'https://media.fatsu.com/fatsoji/flags/Marshall Islands.png',
      },
      {
        name: 'mauritania',
        url: 'https://media.fatsu.com/fatsoji/flags/Mauritania.png',
      },
      {
        name: 'mauritius',
        url: 'https://media.fatsu.com/fatsoji/flags/Mauritius.png',
      },
      {
        name: 'mexico',
        url: 'https://media.fatsu.com/fatsoji/flags/Mexico.png',
      },
      {
        name: 'micronesia',
        url: 'https://media.fatsu.com/fatsoji/flags/Micronesia.png',
      },
      {
        name: 'moldova',
        url: 'https://media.fatsu.com/fatsoji/flags/Moldova.png',
      },
      {
        name: 'mongolia',
        url: 'https://media.fatsu.com/fatsoji/flags/Mongolia.png',
      },
      {
        name: 'montenegro',
        url: 'https://media.fatsu.com/fatsoji/flags/Montenegro.png',
      },
      {
        name: 'morocco',
        url: 'https://media.fatsu.com/fatsoji/flags/Morocco.png',
      },
      {
        name: 'mozambique',
        url: 'https://media.fatsu.com/fatsoji/flags/Mozambique.png',
      },
      {
        name: 'namibia',
        url: 'https://media.fatsu.com/fatsoji/flags/Namibia.png',
      },
      {
        name: 'nauru',
        url: 'https://media.fatsu.com/fatsoji/flags/Nauru.png',
      },
      {
        name: 'nepal',
        url: 'https://media.fatsu.com/fatsoji/flags/Nepal.png',
      },
      {
        name: 'netherlands',
        url: 'https://media.fatsu.com/fatsoji/flags/Netherlands.png',
      },
      {
        name: 'new zealand',
        url: 'https://media.fatsu.com/fatsoji/flags/New Zealand.png',
      },
      {
        name: 'nicaragua',
        url: 'https://media.fatsu.com/fatsoji/flags/Nicaragua.png',
      },
      {
        name: 'niger',
        url: 'https://media.fatsu.com/fatsoji/flags/Niger.png',
      },
      {
        name: 'nigeria-1',
        url: 'https://media.fatsu.com/fatsoji/flags/Nigeria-1.png',
      },
      {
        name: 'nigeria',
        url: 'https://media.fatsu.com/fatsoji/flags/Nigeria.png',
      },
      {
        name: 'north korea',
        url: 'https://media.fatsu.com/fatsoji/flags/North Korea.png',
      },
      {
        name: 'north macedonia',
        url: 'https://media.fatsu.com/fatsoji/flags/North Macedonia.png',
      },
      {
        name: 'norway',
        url: 'https://media.fatsu.com/fatsoji/flags/Norway.png',
      },
      {
        name: 'oman',
        url: 'https://media.fatsu.com/fatsoji/flags/Oman.png',
      },
      {
        name: 'pakistan',
        url: 'https://media.fatsu.com/fatsoji/flags/Pakistan.png',
      },
      {
        name: 'palau',
        url: 'https://media.fatsu.com/fatsoji/flags/Palau.png',
      },
      {
        name: 'papua new guinea',
        url: 'https://media.fatsu.com/fatsoji/flags/Papua New Guinea.png',
      },
      {
        name: 'paraguay',
        url: 'https://media.fatsu.com/fatsoji/flags/Paraguay.png',
      },
      {
        name: 'peru-1',
        url: 'https://media.fatsu.com/fatsoji/flags/Peru-1.png',
      },
      {
        name: 'peru',
        url: 'https://media.fatsu.com/fatsoji/flags/Peru.png',
      },
      {
        name: 'philippines',
        url: 'https://media.fatsu.com/fatsoji/flags/Philippines.png',
      },
      {
        name: 'poland',
        url: 'https://media.fatsu.com/fatsoji/flags/Poland.png',
      },
      {
        name: 'portugal',
        url: 'https://media.fatsu.com/fatsoji/flags/Portugal.png',
      },
      {
        name: 'qatar',
        url: 'https://media.fatsu.com/fatsoji/flags/Qatar.png',
      },
      {
        name: 'republic of the congo',
        url: 'https://media.fatsu.com/fatsoji/flags/Republic of the Congo.png',
      },
      {
        name: 'romania',
        url: 'https://media.fatsu.com/fatsoji/flags/Romania.png',
      },
      {
        name: 'russia',
        url: 'https://media.fatsu.com/fatsoji/flags/Russia.png',
      },
      {
        name: 'rwanda',
        url: 'https://media.fatsu.com/fatsoji/flags/Rwanda.png',
      },
      {
        name: 'saint kitts and nevis',
        url: 'https://media.fatsu.com/fatsoji/flags/Saint Kitts and Nevis.png',
      },
      {
        name: 'saint lucia',
        url: 'https://media.fatsu.com/fatsoji/flags/Saint Lucia.png',
      },
      {
        name: 'saint vincent and the grenadines',
        url: 'https://media.fatsu.com/fatsoji/flags/Saint Vincent and the Grenadines.png',
      },
      {
        name: 'samoa',
        url: 'https://media.fatsu.com/fatsoji/flags/Samoa.png',
      },
      {
        name: 'san marino',
        url: 'https://media.fatsu.com/fatsoji/flags/San Marino.png',
      },
      {
        name: 'saudi arabia',
        url: 'https://media.fatsu.com/fatsoji/flags/Saudi Arabia.png',
      },
      {
        name: 'são tomé and príncipe',
        url: 'https://media.fatsu.com/fatsoji/flags/São Tomé and Príncipe.png',
      },
      {
        name: 'senegal',
        url: 'https://media.fatsu.com/fatsoji/flags/Senegal.png',
      },
      {
        name: 'serbia',
        url: 'https://media.fatsu.com/fatsoji/flags/Serbia.png',
      },
      {
        name: 'seychelles',
        url: 'https://media.fatsu.com/fatsoji/flags/Seychelles.png',
      },
      {
        name: 'sierra leone',
        url: 'https://media.fatsu.com/fatsoji/flags/Sierra Leone.png',
      },
      {
        name: 'singapore',
        url: 'https://media.fatsu.com/fatsoji/flags/Singapore.png',
      },
      {
        name: 'slovakia',
        url: 'https://media.fatsu.com/fatsoji/flags/Slovakia.png',
      },
      {
        name: 'slovenia',
        url: 'https://media.fatsu.com/fatsoji/flags/Slovenia.png',
      },
      {
        name: 'solomon islands',
        url: 'https://media.fatsu.com/fatsoji/flags/Solomon Islands.png',
      },
      {
        name: 'somalia',
        url: 'https://media.fatsu.com/fatsoji/flags/Somalia.png',
      },
      {
        name: 'south africa',
        url: 'https://media.fatsu.com/fatsoji/flags/South Africa.png',
      },
      {
        name: 'south sudan',
        url: 'https://media.fatsu.com/fatsoji/flags/South Sudan.png',
      },
      {
        name: 'spain',
        url: 'https://media.fatsu.com/fatsoji/flags/Spain.png',
      },
      {
        name: 'sri lanka',
        url: 'https://media.fatsu.com/fatsoji/flags/Sri Lanka.png',
      },
      {
        name: 'sudan',
        url: 'https://media.fatsu.com/fatsoji/flags/Sudan.png',
      },
      {
        name: 'sweden',
        url: 'https://media.fatsu.com/fatsoji/flags/Sweden.png',
      },
      {
        name: 'switzerland',
        url: 'https://media.fatsu.com/fatsoji/flags/Switzerland.png',
      },
      {
        name: 'syria',
        url: 'https://media.fatsu.com/fatsoji/flags/Syria.png',
      },
      {
        name: 'tajikistan',
        url: 'https://media.fatsu.com/fatsoji/flags/Tajikistan.png',
      },
      {
        name: 'tanzania',
        url: 'https://media.fatsu.com/fatsoji/flags/Tanzania.png',
      },
      {
        name: 'thailand',
        url: 'https://media.fatsu.com/fatsoji/flags/Thailand.png',
      },
      {
        name: 'the gambia',
        url: 'https://media.fatsu.com/fatsoji/flags/The Gambia.png',
      },
      {
        name: 'timor-leste',
        url: 'https://media.fatsu.com/fatsoji/flags/Timor-Leste.png',
      },
      {
        name: 'togo',
        url: 'https://media.fatsu.com/fatsoji/flags/Togo.png',
      },
      {
        name: 'tonga',
        url: 'https://media.fatsu.com/fatsoji/flags/Tonga.png',
      },
      {
        name: 'trinidad and tobago',
        url: 'https://media.fatsu.com/fatsoji/flags/Trinidad and Tobago.png',
      },
      {
        name: 'tunisia',
        url: 'https://media.fatsu.com/fatsoji/flags/Tunisia.png',
      },
      {
        name: 'turkey',
        url: 'https://media.fatsu.com/fatsoji/flags/Turkey.png',
      },
      {
        name: 'turkmenistan',
        url: 'https://media.fatsu.com/fatsoji/flags/Turkmenistan.png',
      },
      {
        name: 'tuvalu',
        url: 'https://media.fatsu.com/fatsoji/flags/Tuvalu.png',
      },
      {
        name: 'uganda',
        url: 'https://media.fatsu.com/fatsoji/flags/Uganda.png',
      },
      {
        name: 'ukraine',
        url: 'https://media.fatsu.com/fatsoji/flags/Ukraine.png',
      },
      {
        name: 'united arab emirates',
        url: 'https://media.fatsu.com/fatsoji/flags/United Arab Emirates.png',
      },
      {
        name: 'united kingdom',
        url: 'https://media.fatsu.com/fatsoji/flags/United Kingdom.png',
      },
      {
        name: 'united states-1',
        url: 'https://media.fatsu.com/fatsoji/flags/United States-1.png',
      },
      {
        name: 'united states',
        url: 'https://media.fatsu.com/fatsoji/flags/United States.png',
      },
      {
        name: 'uruguay',
        url: 'https://media.fatsu.com/fatsoji/flags/Uruguay.png',
      },
      {
        name: 'uzbekistan',
        url: 'https://media.fatsu.com/fatsoji/flags/Uzbekistan.png',
      },
      {
        name: 'vanuatu',
        url: 'https://media.fatsu.com/fatsoji/flags/Vanuatu.png',
      },
      {
        name: 'vatican city',
        url: 'https://media.fatsu.com/fatsoji/flags/Vatican City.png',
      },
      {
        name: 'venezuela',
        url: 'https://media.fatsu.com/fatsoji/flags/Venezuela.png',
      },
      {
        name: 'vietnam',
        url: 'https://media.fatsu.com/fatsoji/flags/Vietnam.png',
      },
      {
        name: 'yemen',
        url: 'https://media.fatsu.com/fatsoji/flags/Yemen.png',
      },
      {
        name: 'zambia',
        url: 'https://media.fatsu.com/fatsoji/flags/Zambia.png',
      },
      {
        name: 'zimbabwe',
        url: 'https://media.fatsu.com/fatsoji/flags/Zimbabwe.png',
      },
    ],
  },
  {
    categoryIcon: 'https://media.fatsu.com/fatsoji/categories/flowers.svg',
    category: 'flowers',
    emojis: [
      {
        name: 'blossomtree',
        url: 'https://media.fatsu.com/fatsoji/flowers/BlossomTree.png',
      },
      {
        name: 'bouquet',
        url: 'https://media.fatsu.com/fatsoji/flowers/Bouquet.png',
      },
      {
        name: 'daisy',
        url: 'https://media.fatsu.com/fatsoji/flowers/Daisy.png',
      },
      {
        name: 'lily',
        url: 'https://media.fatsu.com/fatsoji/flowers/Lily.png',
      },
      {
        name: 'orchid',
        url: 'https://media.fatsu.com/fatsoji/flowers/Orchid.png',
      },
      {
        name: 'piney',
        url: 'https://media.fatsu.com/fatsoji/flowers/Piney.png',
      },
      {
        name: 'potted',
        url: 'https://media.fatsu.com/fatsoji/flowers/Potted.png',
      },
      {
        name: 'rosy',
        url: 'https://media.fatsu.com/fatsoji/flowers/Rosy.png',
      },
      {
        name: 'sakura',
        url: 'https://media.fatsu.com/fatsoji/flowers/Sakura.png',
      },
      {
        name: 'sprout',
        url: 'https://media.fatsu.com/fatsoji/flowers/Sprout.png',
      },
      {
        name: 'sunflower-1',
        url: 'https://media.fatsu.com/fatsoji/flowers/Sunflower-1.png',
      },
      {
        name: 'sunflower',
        url: 'https://media.fatsu.com/fatsoji/flowers/Sunflower.png',
      },
      {
        name: 'tulip-1',
        url: 'https://media.fatsu.com/fatsoji/flowers/Tulip-1.png',
      },
      {
        name: 'tulip',
        url: 'https://media.fatsu.com/fatsoji/flowers/Tulip.png',
      },
    ],
  },
  {
    category: 'food',
    categoryIcon: 'https://media.fatsu.com/fatsoji/categories/food.svg',
    emojis: [
      {
        name: 'avocado',
        url: 'https://media.fatsu.com/fatsoji/food/Avocado.png',
      },
      {
        name: 'bacon',
        url: 'https://media.fatsu.com/fatsoji/food/Bacon.png',
      },
      {
        name: 'baguette',
        url: 'https://media.fatsu.com/fatsoji/food/Baguette.png',
      },
      {
        name: 'banana',
        url: 'https://media.fatsu.com/fatsoji/food/Banana.png',
      },
      {
        name: 'beer mug',
        url: 'https://media.fatsu.com/fatsoji/food/Beer Mug.png',
      },
      {
        name: 'bell pepper',
        url: 'https://media.fatsu.com/fatsoji/food/Bell Pepper.png',
      },
      {
        name: 'berry muffin',
        url: 'https://media.fatsu.com/fatsoji/food/Berry Muffin.png',
      },
      {
        name: 'berry pineapple',
        url: 'https://media.fatsu.com/fatsoji/food/Berry Pineapple.png',
      },
      {
        name: 'bliss cake',
        url: 'https://media.fatsu.com/fatsoji/food/Bliss Cake.png',
      },
      {
        name: 'blueberry jewel',
        url: 'https://media.fatsu.com/fatsoji/food/Blueberry Jewel.png',
      },
      {
        name: 'bread',
        url: 'https://media.fatsu.com/fatsoji/food/Bread.png',
      },
      {
        name: 'burger',
        url: 'https://media.fatsu.com/fatsoji/food/Burger.png',
      },
      {
        name: 'burrito',
        url: 'https://media.fatsu.com/fatsoji/food/Burrito.png',
      },
      {
        name: 'candy bowl',
        url: 'https://media.fatsu.com/fatsoji/food/Candy Bowl.png',
      },
      {
        name: 'candy pop',
        url: 'https://media.fatsu.com/fatsoji/food/Candy Pop.png',
      },
      {
        name: 'carrot',
        url: 'https://media.fatsu.com/fatsoji/food/Carrot.png',
      },
      {
        name: 'cheese',
        url: 'https://media.fatsu.com/fatsoji/food/Cheese.png',
      },
      {
        name: 'cherry twins',
        url: 'https://media.fatsu.com/fatsoji/food/Cherry Twins.png',
      },
      {
        name: 'chestnut',
        url: 'https://media.fatsu.com/fatsoji/food/Chestnut.png',
      },
      {
        name: 'chicken leg',
        url: 'https://media.fatsu.com/fatsoji/food/Chicken Leg.png',
      },
      {
        name: 'chili',
        url: 'https://media.fatsu.com/fatsoji/food/Chili.png',
      },
      {
        name: 'choco bar',
        url: 'https://media.fatsu.com/fatsoji/food/Choco Bar.png',
      },
      {
        name: 'chocobox',
        url: 'https://media.fatsu.com/fatsoji/food/ChocoBox.png',
      },
      {
        name: 'chocolate bar',
        url: 'https://media.fatsu.com/fatsoji/food/Chocolate Bar.png',
      },
      {
        name: 'clover',
        url: 'https://media.fatsu.com/fatsoji/food/Clover.png',
      },
      {
        name: 'cocktail',
        url: 'https://media.fatsu.com/fatsoji/food/Cocktail.png',
      },
      {
        name: 'coconut',
        url: 'https://media.fatsu.com/fatsoji/food/Coconut.png',
      },
      {
        name: 'cookie-1',
        url: 'https://media.fatsu.com/fatsoji/food/Cookie-1.png',
      },
      {
        name: 'cookie-2',
        url: 'https://media.fatsu.com/fatsoji/food/Cookie-2.png',
      },
      {
        name: 'cookie',
        url: 'https://media.fatsu.com/fatsoji/food/Cookie.png',
      },
      {
        name: 'corn',
        url: 'https://media.fatsu.com/fatsoji/food/Corn.png',
      },
      {
        name: 'criss-cross pie',
        url: 'https://media.fatsu.com/fatsoji/food/Criss-Cross Pie.png',
      },
      {
        name: 'croissant',
        url: 'https://media.fatsu.com/fatsoji/food/Croissant.png',
      },
      {
        name: 'donut-1',
        url: 'https://media.fatsu.com/fatsoji/food/Donut-1.png',
      },
      {
        name: 'donut-2',
        url: 'https://media.fatsu.com/fatsoji/food/Donut-2.png',
      },
      {
        name: 'donut',
        url: 'https://media.fatsu.com/fatsoji/food/Donut.png',
      },
      {
        name: 'dumpling',
        url: 'https://media.fatsu.com/fatsoji/food/Dumpling.png',
      },
      {
        name: 'egg',
        url: 'https://media.fatsu.com/fatsoji/food/Egg.png',
      },
      {
        name: 'eggplant',
        url: 'https://media.fatsu.com/fatsoji/food/Eggplant.png',
      },
      {
        name: 'fig',
        url: 'https://media.fatsu.com/fatsoji/food/Fig.png',
      },
      {
        name: 'fondue',
        url: 'https://media.fatsu.com/fatsoji/food/Fondue.png',
      },
      {
        name: 'fortune',
        url: 'https://media.fatsu.com/fatsoji/food/Fortune.png',
      },
      {
        name: 'fries',
        url: 'https://media.fatsu.com/fatsoji/food/Fries.png',
      },
      {
        name: 'frosted cupcake',
        url: 'https://media.fatsu.com/fatsoji/food/Frosted Cupcake.png',
      },
      {
        name: 'garlic',
        url: 'https://media.fatsu.com/fatsoji/food/Garlic.png',
      },
      {
        name: 'gift box',
        url: 'https://media.fatsu.com/fatsoji/food/Gift Box.png',
      },
      {
        name: 'giftie',
        url: 'https://media.fatsu.com/fatsoji/food/Giftie.png',
      },
      {
        name: 'glitter green apple',
        url: 'https://media.fatsu.com/fatsoji/food/Glitter Green Apple.png',
      },
      {
        name: 'grapes',
        url: 'https://media.fatsu.com/fatsoji/food/Grapes.png',
      },
      {
        name: 'heart strawberry',
        url: 'https://media.fatsu.com/fatsoji/food/Heart Strawberry.png',
      },
      {
        name: 'honey squeeze',
        url: 'https://media.fatsu.com/fatsoji/food/Honey Squeeze.png',
      },
      {
        name: 'hot sauce',
        url: 'https://media.fatsu.com/fatsoji/food/Hot Sauce.png',
      },
      {
        name: 'hotpot',
        url: 'https://media.fatsu.com/fatsoji/food/Hotpot.png',
      },
      {
        name: 'kiwi',
        url: 'https://media.fatsu.com/fatsoji/food/Kiwi.png',
      },
      {
        name: 'lettuce',
        url: 'https://media.fatsu.com/fatsoji/food/Lettuce.png',
      },
      {
        name: 'maple leaf',
        url: 'https://media.fatsu.com/fatsoji/food/Maple Leaf.png',
      },
      {
        name: 'marshmallow swirl',
        url: 'https://media.fatsu.com/fatsoji/food/Marshmallow Swirl.png',
      },
      {
        name: 'martini glass',
        url: 'https://media.fatsu.com/fatsoji/food/Martini Glass.png',
      },
      {
        name: 'matcha cake',
        url: 'https://media.fatsu.com/fatsoji/food/Matcha Cake.png',
      },
      {
        name: 'meat',
        url: 'https://media.fatsu.com/fatsoji/food/Meat.png',
      },
      {
        name: 'melon slice',
        url: 'https://media.fatsu.com/fatsoji/food/Melon Slice.png',
      },
      {
        name: 'mint leaf',
        url: 'https://media.fatsu.com/fatsoji/food/Mint Leaf.png',
      },
      {
        name: 'mooncake',
        url: 'https://media.fatsu.com/fatsoji/food/Mooncake.png',
      },
      {
        name: 'muffin',
        url: 'https://media.fatsu.com/fatsoji/food/Muffin.png',
      },
      {
        name: 'mushroom cap',
        url: 'https://media.fatsu.com/fatsoji/food/Mushroom Cap.png',
      },
      {
        name: 'mushroom',
        url: 'https://media.fatsu.com/fatsoji/food/Mushroom.png',
      },
      {
        name: 'noodles',
        url: 'https://media.fatsu.com/fatsoji/food/Noodles.png',
      },
      {
        name: 'olive',
        url: 'https://media.fatsu.com/fatsoji/food/Olive.png',
      },
      {
        name: 'onigiri',
        url: 'https://media.fatsu.com/fatsoji/food/Onigiri.png',
      },
      {
        name: 'onion',
        url: 'https://media.fatsu.com/fatsoji/food/Onion.png',
      },
      {
        name: 'pancake',
        url: 'https://media.fatsu.com/fatsoji/food/Pancake.png',
      },
      {
        name: 'pancakes',
        url: 'https://media.fatsu.com/fatsoji/food/Pancakes.png',
      },
      {
        name: 'papaya',
        url: 'https://media.fatsu.com/fatsoji/food/Papaya.png',
      },
      {
        name: 'peanut',
        url: 'https://media.fatsu.com/fatsoji/food/Peanut.png',
      },
      {
        name: 'pizza',
        url: 'https://media.fatsu.com/fatsoji/food/Pizza.png',
      },
      {
        name: 'plum',
        url: 'https://media.fatsu.com/fatsoji/food/Plum.png',
      },
      {
        name: 'popsicle',
        url: 'https://media.fatsu.com/fatsoji/food/Popsicle.png',
      },
      {
        name: 'pretzel',
        url: 'https://media.fatsu.com/fatsoji/food/Pretzel.png',
      },
      {
        name: 'purple peach',
        url: 'https://media.fatsu.com/fatsoji/food/Purple Peach.png',
      },
      {
        name: 'rollie',
        url: 'https://media.fatsu.com/fatsoji/food/Rollie.png',
      },
      {
        name: 'salad bowl',
        url: 'https://media.fatsu.com/fatsoji/food/Salad Bowl.png',
      },
      {
        name: 'salad',
        url: 'https://media.fatsu.com/fatsoji/food/Salad.png',
      },
      {
        name: 'salt & pepper',
        url: 'https://media.fatsu.com/fatsoji/food/Salt & Pepper.png',
      },
      {
        name: 'sandwich',
        url: 'https://media.fatsu.com/fatsoji/food/Sandwich.png',
      },
      {
        name: 'sausage-1',
        url: 'https://media.fatsu.com/fatsoji/food/Sausage-1.png',
      },
      {
        name: 'sausage',
        url: 'https://media.fatsu.com/fatsoji/food/Sausage.png',
      },
      {
        name: 'shiny pear',
        url: 'https://media.fatsu.com/fatsoji/food/Shiny Pear.png',
      },
      {
        name: 'sizzle',
        url: 'https://media.fatsu.com/fatsoji/food/Sizzle.png',
      },
      {
        name: 'skewer',
        url: 'https://media.fatsu.com/fatsoji/food/Skewer.png',
      },
      {
        name: 'slices',
        url: 'https://media.fatsu.com/fatsoji/food/Slices.png',
      },
      {
        name: 'smoothie pack',
        url: 'https://media.fatsu.com/fatsoji/food/Smoothie Pack.png',
      },
      {
        name: 'snake gourd',
        url: 'https://media.fatsu.com/fatsoji/food/Snake Gourd.png',
      },
      {
        name: 'soda cup',
        url: 'https://media.fatsu.com/fatsoji/food/Soda Cup.png',
      },
      {
        name: 'softy',
        url: 'https://media.fatsu.com/fatsoji/food/Softy.png',
      },
      {
        name: 'sorbet',
        url: 'https://media.fatsu.com/fatsoji/food/Sorbet.png',
      },
      {
        name: 'soupie',
        url: 'https://media.fatsu.com/fatsoji/food/Soupie.png',
      },
      {
        name: 'sparkling apple',
        url: 'https://media.fatsu.com/fatsoji/food/Sparkling Apple.png',
      },
      {
        name: 'sprinkle donut',
        url: 'https://media.fatsu.com/fatsoji/food/Sprinkle Donut.png',
      },
      {
        name: 'sprinkles',
        url: 'https://media.fatsu.com/fatsoji/food/Sprinkles.png',
      },
      {
        name: 'steak',
        url: 'https://media.fatsu.com/fatsoji/food/Steak.png',
      },
      {
        name: 'stewy',
        url: 'https://media.fatsu.com/fatsoji/food/Stewy.png',
      },
      {
        name: 'strawberry bliss',
        url: 'https://media.fatsu.com/fatsoji/food/Strawberry Bliss.png',
      },
      {
        name: 'sundae',
        url: 'https://media.fatsu.com/fatsoji/food/Sundae.png',
      },
      {
        name: 'sushi',
        url: 'https://media.fatsu.com/fatsoji/food/Sushi.png',
      },
      {
        name: 'taco',
        url: 'https://media.fatsu.com/fatsoji/food/Taco.png',
      },
      {
        name: 'takeout',
        url: 'https://media.fatsu.com/fatsoji/food/Takeout.png',
      },
      {
        name: 'tea cup',
        url: 'https://media.fatsu.com/fatsoji/food/Tea Cup.png',
      },
      {
        name: 'teapot',
        url: 'https://media.fatsu.com/fatsoji/food/Teapot.png',
      },
      {
        name: 'toast',
        url: 'https://media.fatsu.com/fatsoji/food/Toast.png',
      },
      {
        name: 'tomato',
        url: 'https://media.fatsu.com/fatsoji/food/Tomato.png',
      },
      {
        name: 'tropical plum',
        url: 'https://media.fatsu.com/fatsoji/food/Tropical Plum.png',
      },
      {
        name: 'velvet slice',
        url: 'https://media.fatsu.com/fatsoji/food/Velvet Slice.png',
      },
      {
        name: 'waffle',
        url: 'https://media.fatsu.com/fatsoji/food/Waffle.png',
      },
      {
        name: 'watermelon slice',
        url: 'https://media.fatsu.com/fatsoji/food/Watermelon Slice.png',
      },
      {
        name: 'wine glass',
        url: 'https://media.fatsu.com/fatsoji/food/Wine Glass.png',
      },
      {
        name: 'wine glasses',
        url: 'https://media.fatsu.com/fatsoji/food/Wine Glasses.png',
      },
      {
        name: 'zucchini',
        url: 'https://media.fatsu.com/fatsoji/food/Zucchini.png',
      },
      {
        name: 'path2068',
        url: 'https://media.fatsu.com/fatsoji/food/path2068.png',
      },
      {
        name: 'path2070',
        url: 'https://media.fatsu.com/fatsoji/food/path2070.png',
      },
    ],
  },
  {
    category: 'hands',
    categoryIcon: 'https://media.fatsu.com/fatsoji/categories/hands.svg',
    emojis: [
      {
        name: 'backhand pointing left',
        url: 'https://media.fatsu.com/fatsoji/hands/Backhand Pointing Left.png',
      },
      {
        name: 'backhand pointing right',
        url: 'https://media.fatsu.com/fatsoji/hands/Backhand Pointing Right.png',
      },
      {
        name: 'call me hand',
        url: 'https://media.fatsu.com/fatsoji/hands/Call Me Hand.png',
      },
      {
        name: 'clapping hands',
        url: 'https://media.fatsu.com/fatsoji/hands/Clapping Hands.png',
      },
      {
        name: 'crossed fingers',
        url: 'https://media.fatsu.com/fatsoji/hands/Crossed Fingers.png',
      },
      {
        name: 'fist',
        url: 'https://media.fatsu.com/fatsoji/hands/Fist.png',
      },
      {
        name: 'flexed biceps',
        url: 'https://media.fatsu.com/fatsoji/hands/Flexed Biceps.png',
      },
      {
        name: 'folded hands',
        url: 'https://media.fatsu.com/fatsoji/hands/Folded Hands.png',
      },
      {
        name: 'handshake',
        url: 'https://media.fatsu.com/fatsoji/hands/Handshake.png',
      },
      {
        name: 'index pointing up',
        url: 'https://media.fatsu.com/fatsoji/hands/Index Pointing Up.png',
      },
      {
        name: 'leg',
        url: 'https://media.fatsu.com/fatsoji/hands/Leg.png',
      },
      {
        name: 'love-you gesture',
        url: 'https://media.fatsu.com/fatsoji/hands/Love-You Gesture.png',
      },
      {
        name: 'middle finger',
        url: 'https://media.fatsu.com/fatsoji/hands/Middle Finger.png',
      },
      {
        name: 'ok hand',
        url: 'https://media.fatsu.com/fatsoji/hands/OK Hand.png',
      },
      {
        name: 'oncoming fist',
        url: 'https://media.fatsu.com/fatsoji/hands/Oncoming Fist.png',
      },
      {
        name: 'open hands',
        url: 'https://media.fatsu.com/fatsoji/hands/Open Hands.png',
      },
      {
        name: 'pile of poo',
        url: 'https://media.fatsu.com/fatsoji/hands/Pile of Poo.png',
      },
      {
        name: 'pinched fingers',
        url: 'https://media.fatsu.com/fatsoji/hands/Pinched Fingers.png',
      },
      {
        name: 'pinching hand',
        url: 'https://media.fatsu.com/fatsoji/hands/Pinching Hand.png',
      },
      {
        name: 'pointing down',
        url: 'https://media.fatsu.com/fatsoji/hands/Pointing Down.png',
      },
      {
        name: 'pointing left',
        url: 'https://media.fatsu.com/fatsoji/hands/Pointing Left.png',
      },
      {
        name: 'pointing right',
        url: 'https://media.fatsu.com/fatsoji/hands/Pointing Right.png',
      },
      {
        name: 'pointing up',
        url: 'https://media.fatsu.com/fatsoji/hands/Pointing Up.png',
      },
      {
        name: 'praying hands',
        url: 'https://media.fatsu.com/fatsoji/hands/Praying Hands.png',
      },
      {
        name: 'prey',
        url: 'https://media.fatsu.com/fatsoji/hands/Prey.png',
      },
      {
        name: 'raised hand',
        url: 'https://media.fatsu.com/fatsoji/hands/Raised Hand.png',
      },
      {
        name: 'sign of the horns',
        url: 'https://media.fatsu.com/fatsoji/hands/Sign of the Horns.png',
      },
      {
        name: 'thumbs down',
        url: 'https://media.fatsu.com/fatsoji/hands/Thumbs Down.png',
      },
      {
        name: 'thumbs up',
        url: 'https://media.fatsu.com/fatsoji/hands/Thumbs Up.png',
      },
      {
        name: 'victory hand',
        url: 'https://media.fatsu.com/fatsoji/hands/Victory Hand.png',
      },
      {
        name: 'vulcan salute',
        url: 'https://media.fatsu.com/fatsoji/hands/Vulcan Salute.png',
      },
      {
        name: 'waving hand',
        url: 'https://media.fatsu.com/fatsoji/hands/Waving Hand.png',
      },
      {
        name: 'writing hand',
        url: 'https://media.fatsu.com/fatsoji/hands/Writing Hand.png',
      },
    ],
  },
  {
    category: 'love',
    categoryIcon: 'https://media.fatsu.com/fatsoji/categories/love.svg',
    emojis: [
      {
        name: '#bff',
        url: 'https://media.fatsu.com/fatsoji/love/%23BFF.png',
      },
      {
        name: 'banner',
        url: 'https://media.fatsu.com/fatsoji/love/Banner.png',
      },
      {
        name: 'chat',
        url: 'https://media.fatsu.com/fatsoji/love/Chat.png',
      },
      {
        name: 'cool',
        url: 'https://media.fatsu.com/fatsoji/love/Cool.png',
      },
      {
        name: 'good vibes-1',
        url: 'https://media.fatsu.com/fatsoji/love/Good Vibes-1.png',
      },
      {
        name: 'good vibes',
        url: 'https://media.fatsu.com/fatsoji/love/Good Vibes.png',
      },
      {
        name: 'heart frame',
        url: 'https://media.fatsu.com/fatsoji/love/Heart Frame.png',
      },
      {
        name: 'heart with ribbon',
        url: 'https://media.fatsu.com/fatsoji/love/Heart with Ribbon.png',
      },
      {
        name: 'kissy lips',
        url: 'https://media.fatsu.com/fatsoji/love/Kissy Lips.png',
      },
      {
        name: 'love',
        url: 'https://media.fatsu.com/fatsoji/love/Love.png',
      },
      {
        name: 'omg',
        url: 'https://media.fatsu.com/fatsoji/love/OMG.png',
      },
      {
        name: 'oh happy',
        url: 'https://media.fatsu.com/fatsoji/love/Oh Happy.png',
      },
      {
        name: 'oh yeah!',
        url: 'https://media.fatsu.com/fatsoji/love/Oh Yeah!.png',
      },
      {
        name: 'party popper',
        url: 'https://media.fatsu.com/fatsoji/love/Party Popper.png',
      },
      {
        name: 'rock on',
        url: 'https://media.fatsu.com/fatsoji/love/Rock On.png',
      },
      {
        name: 'rose-1',
        url: 'https://media.fatsu.com/fatsoji/love/Rose-1.png',
      },
      {
        name: 'rose',
        url: 'https://media.fatsu.com/fatsoji/love/Rose.png',
      },
      {
        name: 'spark',
        url: 'https://media.fatsu.com/fatsoji/love/Spark.png',
      },
      {
        name: 'speech bubble',
        url: 'https://media.fatsu.com/fatsoji/love/Speech Bubble.png',
      },
      {
        name: 'cross_finger',
        url: 'https://media.fatsu.com/fatsoji/love/cross_finger.png',
      },
    ],
  },
  {
    category: 'office tools',
    categoryIcon: 'https://media.fatsu.com/fatsoji/categories/tools.svg',
    emojis: [
      {
        name: 'binder',
        url: 'https://media.fatsu.com/fatsoji/office_tools/Binder.png',
      },
      {
        name: 'book',
        url: 'https://media.fatsu.com/fatsoji/office_tools/Book.png',
      },
      {
        name: 'bookmark',
        url: 'https://media.fatsu.com/fatsoji/office_tools/Bookmark.png',
      },
      {
        name: 'books',
        url: 'https://media.fatsu.com/fatsoji/office_tools/Books.png',
      },
      {
        name: 'briefcase',
        url: 'https://media.fatsu.com/fatsoji/office_tools/Briefcase.png',
      },
      {
        name: 'calendar',
        url: 'https://media.fatsu.com/fatsoji/office_tools/Calendar.png',
      },
      {
        name: 'clipboard',
        url: 'https://media.fatsu.com/fatsoji/office_tools/Clipboard.png',
      },
      {
        name: 'closed book',
        url: 'https://media.fatsu.com/fatsoji/office_tools/Closed Book.png',
      },
      {
        name: 'closed notebook',
        url: 'https://media.fatsu.com/fatsoji/office_tools/Closed Notebook.png',
      },
      {
        name: 'coin',
        url: 'https://media.fatsu.com/fatsoji/office_tools/Coin.png',
      },
      {
        name: 'credit card',
        url: 'https://media.fatsu.com/fatsoji/office_tools/Credit Card.png',
      },
      {
        name: 'document with curl',
        url: 'https://media.fatsu.com/fatsoji/office_tools/Document with Curl.png',
      },
      {
        name: 'download folder',
        url: 'https://media.fatsu.com/fatsoji/office_tools/Download Folder.png',
      },
      {
        name: 'email sent',
        url: 'https://media.fatsu.com/fatsoji/office_tools/Email sent.png',
      },
      {
        name: 'email',
        url: 'https://media.fatsu.com/fatsoji/office_tools/Email.png',
      },
      {
        name: 'envelope',
        url: 'https://media.fatsu.com/fatsoji/office_tools/Envelope.png',
      },
      {
        name: 'inbox',
        url: 'https://media.fatsu.com/fatsoji/office_tools/Inbox.png',
      },
      {
        name: 'ledger notebook',
        url: 'https://media.fatsu.com/fatsoji/office_tools/Ledger Notebook.png',
      },
      {
        name: 'ledger',
        url: 'https://media.fatsu.com/fatsoji/office_tools/Ledger.png',
      },
      {
        name: 'linked paperclips',
        url: 'https://media.fatsu.com/fatsoji/office_tools/Linked Paperclips.png',
      },
      {
        name: 'mailbox flag up',
        url: 'https://media.fatsu.com/fatsoji/office_tools/Mailbox Flag Up.png',
      },
      {
        name: 'mailbox with letter',
        url: 'https://media.fatsu.com/fatsoji/office_tools/Mailbox with Letter.png',
      },
      {
        name: 'mailbox with package',
        url: 'https://media.fatsu.com/fatsoji/office_tools/Mailbox with Package.png',
      },
      {
        name: 'mailbox',
        url: 'https://media.fatsu.com/fatsoji/office_tools/Mailbox.png',
      },
      {
        name: 'money bag',
        url: 'https://media.fatsu.com/fatsoji/office_tools/Money Bag.png',
      },
      {
        name: 'money with dollar wings-1',
        url: 'https://media.fatsu.com/fatsoji/office_tools/Money with Dollar Wings-1.png',
      },
      {
        name: 'money with dollar wings',
        url: 'https://media.fatsu.com/fatsoji/office_tools/Money with Dollar Wings.png',
      },
      {
        name: 'money with euro sign',
        url: 'https://media.fatsu.com/fatsoji/office_tools/Money with Euro Sign.png',
      },
      {
        name: 'money with pound sign',
        url: 'https://media.fatsu.com/fatsoji/office_tools/Money with Pound Sign.png',
      },
      {
        name: 'money with wings',
        url: 'https://media.fatsu.com/fatsoji/office_tools/Money with Wings.png',
      },
      {
        name: 'newspaper',
        url: 'https://media.fatsu.com/fatsoji/office_tools/Newspaper.png',
      },
      {
        name: 'notebook with cover',
        url: 'https://media.fatsu.com/fatsoji/office_tools/Notebook with Cover.png',
      },
      {
        name: 'notebook',
        url: 'https://media.fatsu.com/fatsoji/office_tools/Notebook.png',
      },
      {
        name: 'open book',
        url: 'https://media.fatsu.com/fatsoji/office_tools/Open Book.png',
      },
      {
        name: 'open mailbox',
        url: 'https://media.fatsu.com/fatsoji/office_tools/Open Mailbox.png',
      },
      {
        name: 'page with curl (missed earlier)',
        url: 'https://media.fatsu.com/fatsoji/office_tools/Page with Curl (missed earlier).png',
      },
      {
        name: 'page with curl',
        url: 'https://media.fatsu.com/fatsoji/office_tools/Page with Curl.png',
      },
      {
        name: 'page',
        url: 'https://media.fatsu.com/fatsoji/office_tools/Page.png',
      },
      {
        name: 'paperclip',
        url: 'https://media.fatsu.com/fatsoji/office_tools/Paperclip.png',
      },
      {
        name: 'pushpin',
        url: 'https://media.fatsu.com/fatsoji/office_tools/Pushpin.png',
      },
      {
        name: 'receipt',
        url: 'https://media.fatsu.com/fatsoji/office_tools/Receipt.png',
      },
      {
        name: 'rolled-up document',
        url: 'https://media.fatsu.com/fatsoji/office_tools/Rolled-Up Document.png',
      },
      {
        name: 'rolled-up newspaper',
        url: 'https://media.fatsu.com/fatsoji/office_tools/Rolled-Up Newspaper.png',
      },
      {
        name: 'scissors',
        url: 'https://media.fatsu.com/fatsoji/office_tools/Scissors.png',
      },
      {
        name: 'spiral calendar',
        url: 'https://media.fatsu.com/fatsoji/office_tools/Spiral Calendar.png',
      },
      {
        name: 'spiral notepad',
        url: 'https://media.fatsu.com/fatsoji/office_tools/Spiral Notepad.png',
      },
      {
        name: 'straight ruler (again)',
        url: 'https://media.fatsu.com/fatsoji/office_tools/Straight Ruler (again).png',
      },
      {
        name: 'straight ruler',
        url: 'https://media.fatsu.com/fatsoji/office_tools/Straight Ruler.png',
      },
      {
        name: 'tear-off calendar',
        url: 'https://media.fatsu.com/fatsoji/office_tools/Tear-Off Calendar.png',
      },
      {
        name: 'triangular ruler',
        url: 'https://media.fatsu.com/fatsoji/office_tools/Triangular Ruler.png',
      },
      {
        name: 'wastebasket',
        url: 'https://media.fatsu.com/fatsoji/office_tools/Wastebasket.png',
      },
      {
        name: 'reading mail',
        url: 'https://media.fatsu.com/fatsoji/office_tools/reading mail.png',
      },
    ],
  },
  {
    category: 'smiles',
    categoryIcon: 'https://media.fatsu.com/fatsoji/categories/smile.svg',
    emojis: [
      {
        name: 'alienadmire',
        url: 'https://media.fatsu.com/fatsoji/smlies/AlienAdmire.png',
      },
      {
        name: 'angry pins',
        url: 'https://media.fatsu.com/fatsoji/smlies/Angry Pins.png',
      },
      {
        name: 'angrycycle',
        url: 'https://media.fatsu.com/fatsoji/smlies/AngryCycle.png',
      },
      {
        name: 'big eyes boo',
        url: 'https://media.fatsu.com/fatsoji/smlies/Big Eyes Boo.png',
      },
      {
        name: 'blush smile',
        url: 'https://media.fatsu.com/fatsoji/smlies/Blush Smile.png',
      },
      {
        name: 'blushing face',
        url: 'https://media.fatsu.com/fatsoji/smlies/Blushing Face.png',
      },
      {
        name: 'blushy bliss',
        url: 'https://media.fatsu.com/fatsoji/smlies/Blushy Bliss.png',
      },
      {
        name: 'blushylove',
        url: 'https://media.fatsu.com/fatsoji/smlies/BlushyLove.png',
      },
      {
        name: 'bookworm',
        url: 'https://media.fatsu.com/fatsoji/smlies/Bookworm.png',
      },
      {
        name: 'breathless',
        url: 'https://media.fatsu.com/fatsoji/smlies/Breathless.png',
      },
      {
        name: 'bright-eyed wonder',
        url: 'https://media.fatsu.com/fatsoji/smlies/Bright-Eyed Wonder.png',
      },
      {
        name: 'brow brusher',
        url: 'https://media.fatsu.com/fatsoji/smlies/Brow Brusher.png',
      },
      {
        name: 'camera roll',
        url: 'https://media.fatsu.com/fatsoji/smlies/Camera Roll.png',
      },
      {
        name: 'cheekyheart',
        url: 'https://media.fatsu.com/fatsoji/smlies/CheekyHeart.png',
      },
      {
        name: 'cheery eyes',
        url: 'https://media.fatsu.com/fatsoji/smlies/Cheery Eyes.png',
      },
      {
        name: 'cloudy tears',
        url: 'https://media.fatsu.com/fatsoji/smlies/Cloudy Tears.png',
      },
      {
        name: 'confused curious',
        url: 'https://media.fatsu.com/fatsoji/smlies/Confused Curious.png',
      },
      {
        name: 'confusedcare',
        url: 'https://media.fatsu.com/fatsoji/smlies/ConfusedCare.png',
      },
      {
        name: 'cookie crumble',
        url: 'https://media.fatsu.com/fatsoji/smlies/Cookie Crumble.png',
      },
      {
        name: 'cool shades',
        url: 'https://media.fatsu.com/fatsoji/smlies/Cool Shades.png',
      },
      {
        name: 'crosseyedquirk',
        url: 'https://media.fatsu.com/fatsoji/smlies/CrossEyedQuirk.png',
      },
      {
        name: 'crybaby',
        url: 'https://media.fatsu.com/fatsoji/smlies/Crybaby.png',
      },
      {
        name: "cupid's arrow",
        url: "https://media.fatsu.com/fatsoji/smlies/Cupid's Arrow.png",
      },
      {
        name: 'devilish grin',
        url: 'https://media.fatsu.com/fatsoji/smlies/Devilish Grin.png',
      },
      {
        name: 'dizzyshock',
        url: 'https://media.fatsu.com/fatsoji/smlies/DizzyShock.png',
      },
      {
        name: 'doublehearts',
        url: 'https://media.fatsu.com/fatsoji/smlies/DoubleHearts.png',
      },
      {
        name: 'dreamyeyes',
        url: 'https://media.fatsu.com/fatsoji/smlies/DreamyEyes.png',
      },
      {
        name: 'egg sponge',
        url: 'https://media.fatsu.com/fatsoji/smlies/Egg Sponge.png',
      },
      {
        name: 'face mask',
        url: 'https://media.fatsu.com/fatsoji/smlies/Face Mask.png',
      },
      {
        name: 'fancy tie',
        url: 'https://media.fatsu.com/fatsoji/smlies/Fancy Tie.png',
      },
      {
        name: 'feverface',
        url: 'https://media.fatsu.com/fatsoji/smlies/FeverFace.png',
      },
      {
        name: 'furious flame',
        url: 'https://media.fatsu.com/fatsoji/smlies/Furious Flame.png',
      },
      {
        name: 'gooey gross',
        url: 'https://media.fatsu.com/fatsoji/smlies/Gooey Gross.png',
      },
      {
        name: 'grinmaster',
        url: 'https://media.fatsu.com/fatsoji/smlies/GrinMaster.png',
      },
      {
        name: 'hair roller',
        url: 'https://media.fatsu.com/fatsoji/smlies/Hair Roller.png',
      },
      {
        name: 'heartglow',
        url: 'https://media.fatsu.com/fatsoji/smlies/HeartGlow.png',
      },
      {
        name: 'huggy warmth',
        url: 'https://media.fatsu.com/fatsoji/smlies/Huggy Warmth.png',
      },
      {
        name: 'hydro helper',
        url: 'https://media.fatsu.com/fatsoji/smlies/Hydro Helper.png',
      },
      {
        name: 'ice cream joy',
        url: 'https://media.fatsu.com/fatsoji/smlies/Ice Cream Joy.png',
      },
      {
        name: 'laughy shades',
        url: 'https://media.fatsu.com/fatsoji/smlies/Laughy Shades.png',
      },
      {
        name: 'lonely shadow',
        url: 'https://media.fatsu.com/fatsoji/smlies/Lonely Shadow.png',
      },
      {
        name: 'lovepainter',
        url: 'https://media.fatsu.com/fatsoji/smlies/LovePainter.png',
      },
      {
        name: 'lovey heart',
        url: 'https://media.fatsu.com/fatsoji/smlies/Lovey Heart.png',
      },
      {
        name: 'mascara magic',
        url: 'https://media.fatsu.com/fatsoji/smlies/Mascara Magic.png',
      },
      {
        name: 'maskedcare',
        url: 'https://media.fatsu.com/fatsoji/smlies/MaskedCare.png',
      },
      {
        name: 'melony bliss',
        url: 'https://media.fatsu.com/fatsoji/smlies/Melony Bliss.png',
      },
      {
        name: 'melted marvel',
        url: 'https://media.fatsu.com/fatsoji/smlies/Melted Marvel.png',
      },
      {
        name: 'mirror check',
        url: 'https://media.fatsu.com/fatsoji/smlies/Mirror Check.png',
      },
      {
        name: 'moneymouth',
        url: 'https://media.fatsu.com/fatsoji/smlies/MoneyMouth.png',
      },
      {
        name: 'mystery mask',
        url: 'https://media.fatsu.com/fatsoji/smlies/Mystery Mask.png',
      },
      {
        name: 'nerdy spectacle',
        url: 'https://media.fatsu.com/fatsoji/smlies/Nerdy Spectacle.png',
      },
      {
        name: 'panic',
        url: 'https://media.fatsu.com/fatsoji/smlies/Panic.png',
      },
      {
        name: 'party scream',
        url: 'https://media.fatsu.com/fatsoji/smlies/Party Scream.png',
      },
      {
        name: 'partymood',
        url: 'https://media.fatsu.com/fatsoji/smlies/PartyMood.png',
      },
      {
        name: 'powder puff',
        url: 'https://media.fatsu.com/fatsoji/smlies/Powder Puff.png',
      },
      {
        name: 'puppy eyes',
        url: 'https://media.fatsu.com/fatsoji/smlies/Puppy Eyes.png',
      },
      {
        name: 'questionconfused',
        url: 'https://media.fatsu.com/fatsoji/smlies/QuestionConfused.png',
      },
      {
        name: 'sad drop',
        url: 'https://media.fatsu.com/fatsoji/smlies/Sad Drop.png',
      },
      {
        name: 'scaredy skull',
        url: 'https://media.fatsu.com/fatsoji/smlies/Scaredy Skull.png',
      },
      {
        name: 'shockface',
        url: 'https://media.fatsu.com/fatsoji/smlies/ShockFace.png',
      },
      {
        name: 'shocked square',
        url: 'https://media.fatsu.com/fatsoji/smlies/Shocked Square.png',
      },
      {
        name: 'shocked surprise',
        url: 'https://media.fatsu.com/fatsoji/smlies/Shocked Surprise.png',
      },
      {
        name: 'shockedaffection',
        url: 'https://media.fatsu.com/fatsoji/smlies/ShockedAffection.png',
      },
      {
        name: 'shutit',
        url: 'https://media.fatsu.com/fatsoji/smlies/ShutIt.png',
      },
      {
        name: 'side-eye sneak',
        url: 'https://media.fatsu.com/fatsoji/smlies/Side-Eye Sneak.png',
      },
      {
        name: 'sleepy snooze',
        url: 'https://media.fatsu.com/fatsoji/smlies/Sleepy Snooze.png',
      },
      {
        name: 'sleepy snoozer',
        url: 'https://media.fatsu.com/fatsoji/smlies/Sleepy Snoozer.png',
      },
      {
        name: 'sleepy square',
        url: 'https://media.fatsu.com/fatsoji/smlies/Sleepy Square.png',
      },
      {
        name: 'smiley shades',
        url: 'https://media.fatsu.com/fatsoji/smlies/Smiley Shades.png',
      },
      {
        name: 'starstruck',
        url: 'https://media.fatsu.com/fatsoji/smlies/Starstruck.png',
      },
      {
        name: 'surprisedsoul',
        url: 'https://media.fatsu.com/fatsoji/smlies/SurprisedSoul.png',
      },
      {
        name: 'swirly eyes',
        url: 'https://media.fatsu.com/fatsoji/smlies/Swirly Eyes.png',
      },
      {
        name: 'tearylove',
        url: 'https://media.fatsu.com/fatsoji/smlies/TearyLove.png',
      },
      {
        name: 'tearysadness',
        url: 'https://media.fatsu.com/fatsoji/smlies/TearySadness.png',
      },
      {
        name: 'tongue out',
        url: 'https://media.fatsu.com/fatsoji/smlies/Tongue Out.png',
      },
      {
        name: 'uneasycrush-1',
        url: 'https://media.fatsu.com/fatsoji/smlies/UneasyCrush-1.png',
      },
      {
        name: 'uneasycrush',
        url: 'https://media.fatsu.com/fatsoji/smlies/UneasyCrush.png',
      },
      {
        name: 'whiskered whimsy',
        url: 'https://media.fatsu.com/fatsoji/smlies/Whiskered Whimsy.png',
      },
      {
        name: 'wide eyed wonder',
        url: 'https://media.fatsu.com/fatsoji/smlies/Wide Eyed Wonder.png',
      },
      {
        name: 'wide-eyedlove',
        url: 'https://media.fatsu.com/fatsoji/smlies/Wide-EyedLove.png',
      },
      {
        name: 'wide-eyedsurprise',
        url: 'https://media.fatsu.com/fatsoji/smlies/Wide-EyedSurprise.png',
      },
      {
        name: 'zipped lips',
        url: 'https://media.fatsu.com/fatsoji/smlies/Zipped Lips.png',
      },
      {
        name: 'call',
        url: 'https://media.fatsu.com/fatsoji/smlies/call.png',
      },
      {
        name: 'listen',
        url: 'https://media.fatsu.com/fatsoji/smlies/listen.png',
      },
      {
        name: 'party-1',
        url: 'https://media.fatsu.com/fatsoji/smlies/party-1.png',
      },
      {
        name: 'party',
        url: 'https://media.fatsu.com/fatsoji/smlies/party.png',
      },
      {
        name: 'reading-1',
        url: 'https://media.fatsu.com/fatsoji/smlies/reading-1.png',
      },
      {
        name: 'reading-2',
        url: 'https://media.fatsu.com/fatsoji/smlies/reading-2.png',
      },
      {
        name: 'reading',
        url: 'https://media.fatsu.com/fatsoji/smlies/reading.png',
      },
      {
        name: 'shutup',
        url: 'https://media.fatsu.com/fatsoji/smlies/shutup.png',
      },
    ],
  },
  {
    category: 'sports',
    categoryIcon: 'https://media.fatsu.com/fatsoji/categories/sports.svg',
    emojis: [
      {
        name: 'slots',
        url: 'https://media.fatsu.com/fatsoji/sports/876.png',
      },
      {
        name: 'admission tickets',
        url: 'https://media.fatsu.com/fatsoji/sports/Admission Tickets.png',
      },
      {
        name: 'badminton',
        url: 'https://media.fatsu.com/fatsoji/sports/Badminton.png',
      },
      {
        name: 'baseball cap',
        url: 'https://media.fatsu.com/fatsoji/sports/Baseball Cap.png',
      },
      {
        name: 'baseball',
        url: 'https://media.fatsu.com/fatsoji/sports/Baseball.png',
      },
      {
        name: 'basketball',
        url: 'https://media.fatsu.com/fatsoji/sports/Basketball.png',
      },
      {
        name: 'beads',
        url: 'https://media.fatsu.com/fatsoji/sports/Beads.png',
      },
      {
        name: 'boomerang',
        url: 'https://media.fatsu.com/fatsoji/sports/Boomerang.png',
      },
      {
        name: 'bow and arrow',
        url: 'https://media.fatsu.com/fatsoji/sports/Bow and Arrow.png',
      },
      {
        name: 'bowling',
        url: 'https://media.fatsu.com/fatsoji/sports/Bowling.png',
      },
      {
        name: 'boxing glove',
        url: 'https://media.fatsu.com/fatsoji/sports/Boxing Glove.png',
      },
      {
        name: 'chess pawn',
        url: 'https://media.fatsu.com/fatsoji/sports/Chess Pawn.png',
      },
      {
        name: 'construction helmet',
        url: 'https://media.fatsu.com/fatsoji/sports/Construction Helmet.png',
      },
      {
        name: 'cricket game',
        url: 'https://media.fatsu.com/fatsoji/sports/Cricket Game.png',
      },
      {
        name: 'crossed swords',
        url: 'https://media.fatsu.com/fatsoji/sports/Crossed Swords.png',
      },
      {
        name: 'crystal ball',
        url: 'https://media.fatsu.com/fatsoji/sports/Crystal Ball.png',
      },
      {
        name: 'curling stone',
        url: 'https://media.fatsu.com/fatsoji/sports/Curling Stone.png',
      },
      {
        name: 'dartboard',
        url: 'https://media.fatsu.com/fatsoji/sports/Dartboard.png',
      },
      {
        name: 'die',
        url: 'https://media.fatsu.com/fatsoji/sports/Die.png',
      },
      {
        name: 'diving mask',
        url: 'https://media.fatsu.com/fatsoji/sports/Diving Mask.png',
      },
      {
        name: 'field hockey',
        url: 'https://media.fatsu.com/fatsoji/sports/Field Hockey.png',
      },
      {
        name: 'first place medal',
        url: 'https://media.fatsu.com/fatsoji/sports/First Place Medal.png',
      },
      {
        name: 'flag in hole (golf)',
        url: 'https://media.fatsu.com/fatsoji/sports/Flag in Hole (Golf).png',
      },
      {
        name: 'frisbee',
        url: 'https://media.fatsu.com/fatsoji/sports/Frisbee.png',
      },
      {
        name: 'goal net',
        url: 'https://media.fatsu.com/fatsoji/sports/Goal Net.png',
      },
      {
        name: 'helmet',
        url: 'https://media.fatsu.com/fatsoji/sports/Helmet.png',
      },
      {
        name: 'ice hockey',
        url: 'https://media.fatsu.com/fatsoji/sports/Ice Hockey.png',
      },
      {
        name: 'ice skate (missed earlier, my apologies!)',
        url: 'https://media.fatsu.com/fatsoji/sports/Ice Skate (missed earlier, my apologies!).png',
      },
      {
        name: 'ice skate',
        url: 'https://media.fatsu.com/fatsoji/sports/Ice Skate.png',
      },
      {
        name: 'kite',
        url: 'https://media.fatsu.com/fatsoji/sports/Kite.png',
      },
      {
        name: 'lacrosse',
        url: 'https://media.fatsu.com/fatsoji/sports/Lacrosse.png',
      },
      {
        name: 'life vest',
        url: 'https://media.fatsu.com/fatsoji/sports/Life Vest.png',
      },
      {
        name: 'magic 8-ball',
        url: 'https://media.fatsu.com/fatsoji/sports/Magic 8-Ball.png',
      },
      {
        name: 'magic wand',
        url: 'https://media.fatsu.com/fatsoji/sports/Magic Wand.png',
      },
      {
        name: 'martial arts uniform',
        url: 'https://media.fatsu.com/fatsoji/sports/Martial Arts Uniform.png',
      },
      {
        name: 'military medal',
        url: 'https://media.fatsu.com/fatsoji/sports/Military Medal.png',
      },
      {
        name: 'mobile (hanging toy)',
        url: 'https://media.fatsu.com/fatsoji/sports/Mobile (Hanging Toy).png',
      },
      {
        name: 'nesting dolls',
        url: 'https://media.fatsu.com/fatsoji/sports/Nesting Dolls.png',
      },
      {
        name: 'performing arts (theater masks)',
        url: 'https://media.fatsu.com/fatsoji/sports/Performing Arts (Theater Masks).png',
      },
      {
        name: 'ping pong (table tennis)',
        url: 'https://media.fatsu.com/fatsoji/sports/Ping Pong (Table Tennis).png',
      },
      {
        name: 'piñata',
        url: 'https://media.fatsu.com/fatsoji/sports/Piñata.png',
      },
      {
        name: 'puzzle piece',
        url: 'https://media.fatsu.com/fatsoji/sports/Puzzle Piece.png',
      },
      {
        name: 'rugby ball',
        url: 'https://media.fatsu.com/fatsoji/sports/Rugby ball.png',
      },
      {
        name: 'rugby ball_2',
        url: 'https://media.fatsu.com/fatsoji/sports/Rugby ball_2.png',
      },
      {
        name: 'second place medal',
        url: 'https://media.fatsu.com/fatsoji/sports/Second Place Medal.png',
      },
      {
        name: 'shield',
        url: 'https://media.fatsu.com/fatsoji/sports/Shield.png',
      },
      {
        name: 'sled',
        url: 'https://media.fatsu.com/fatsoji/sports/Sled.png',
      },
      {
        name: 'slot machine',
        url: 'https://media.fatsu.com/fatsoji/sports/Slot Machine.png',
      },
      {
        name: 'soccer ball',
        url: 'https://media.fatsu.com/fatsoji/sports/Soccer Ball.png',
      },
      {
        name: 'softball',
        url: 'https://media.fatsu.com/fatsoji/sports/Softball.png',
      },
      {
        name: 'sports medal',
        url: 'https://media.fatsu.com/fatsoji/sports/Sports Medal.png',
      },
      {
        name: 'sword',
        url: 'https://media.fatsu.com/fatsoji/sports/Sword.png',
      },
      {
        name: 'table tennis paddle and ball',
        url: 'https://media.fatsu.com/fatsoji/sports/Table Tennis Paddle and Ball.png',
      },
      {
        name: 'teddy bear',
        url: 'https://media.fatsu.com/fatsoji/sports/Teddy Bear.png',
      },
      {
        name: 'tennis racket and ball',
        url: 'https://media.fatsu.com/fatsoji/sports/Tennis Racket and Ball.png',
      },
      {
        name: 'third place medal',
        url: 'https://media.fatsu.com/fatsoji/sports/Third Place Medal.png',
      },
      {
        name: 'ticket',
        url: 'https://media.fatsu.com/fatsoji/sports/Ticket.png',
      },
      {
        name: 'toy',
        url: 'https://media.fatsu.com/fatsoji/sports/Toy.png',
      },
      {
        name: 'trophy',
        url: 'https://media.fatsu.com/fatsoji/sports/Trophy.png',
      },
      {
        name: 'video game controller',
        url: 'https://media.fatsu.com/fatsoji/sports/Video Game Controller.png',
      },
      {
        name: 'volleyball',
        url: 'https://media.fatsu.com/fatsoji/sports/Volleyball.png',
      },
      {
        name: 'water gun',
        url: 'https://media.fatsu.com/fatsoji/sports/Water Gun.png',
      },
      {
        name: 'yo-yo',
        url: 'https://media.fatsu.com/fatsoji/sports/Yo-Yo.png',
      },
      {
        name: 'cycling',
        url: 'https://media.fatsu.com/fatsoji/sports/cycling.png',
      },
    ],
  },
  {
    category: 'study',
    categoryIcon: 'https://media.fatsu.com/fatsoji/categories/study.svg',
    emojis: [
      {
        name: 'artist palette',
        url: 'https://media.fatsu.com/fatsoji/study/Artist Palette.png',
      },
      {
        name: 'bone',
        url: 'https://media.fatsu.com/fatsoji/study/Bone.png',
      },
      {
        name: 'brain',
        url: 'https://media.fatsu.com/fatsoji/study/Brain.png',
      },
      {
        name: 'dna',
        url: 'https://media.fatsu.com/fatsoji/study/DNA.png',
      },
      {
        name: 'donut eye',
        url: 'https://media.fatsu.com/fatsoji/study/Donut Eye.png',
      },
      {
        name: 'ear',
        url: 'https://media.fatsu.com/fatsoji/study/Ear.png',
      },
      {
        name: 'eyeballs',
        url: 'https://media.fatsu.com/fatsoji/study/Eyeballs.png',
      },
      {
        name: 'foot',
        url: 'https://media.fatsu.com/fatsoji/study/Foot.png',
      },
      {
        name: 'fountain pen',
        url: 'https://media.fatsu.com/fatsoji/study/Fountain Pen.png',
      },
      {
        name: 'heart',
        url: 'https://media.fatsu.com/fatsoji/study/Heart.png',
      },
      {
        name: 'highlighter',
        url: 'https://media.fatsu.com/fatsoji/study/Highlighter.png',
      },
      {
        name: 'lips',
        url: 'https://media.fatsu.com/fatsoji/study/Lips.png',
      },
      {
        name: 'lungs',
        url: 'https://media.fatsu.com/fatsoji/study/Lungs.png',
      },
      {
        name: 'marker',
        url: 'https://media.fatsu.com/fatsoji/study/Marker.png',
      },
      {
        name: 'mechanical arm',
        url: 'https://media.fatsu.com/fatsoji/study/Mechanical Arm.png',
      },
      {
        name: 'microscope',
        url: 'https://media.fatsu.com/fatsoji/study/Microscope.png',
      },
      {
        name: 'nose',
        url: 'https://media.fatsu.com/fatsoji/study/Nose.png',
      },
      {
        name: 'paintbrush',
        url: 'https://media.fatsu.com/fatsoji/study/Paintbrush.png',
      },
      {
        name: 'paper document with pen',
        url: 'https://media.fatsu.com/fatsoji/study/Paper Document with Pen.png',
      },
      {
        name: 'pencil',
        url: 'https://media.fatsu.com/fatsoji/study/Pencil.png',
      },
      {
        name: 'petri dish.',
        url: 'https://media.fatsu.com/fatsoji/study/Petri Dish..png',
      },
      {
        name: 'prosthetic leg',
        url: 'https://media.fatsu.com/fatsoji/study/Prosthetic Leg.png',
      },
      {
        name: 'satellite dish',
        url: 'https://media.fatsu.com/fatsoji/study/Satellite Dish.png',
      },
      {
        name: 'test tube',
        url: 'https://media.fatsu.com/fatsoji/study/Test Tube.png',
      },
      {
        name: 'tongue',
        url: 'https://media.fatsu.com/fatsoji/study/Tongue.png',
      },
      {
        name: 'tooth',
        url: 'https://media.fatsu.com/fatsoji/study/Tooth.png',
      },
    ],
  },
  {
    category: 'travel',
    categoryIcon: 'https://media.fatsu.com/fatsoji/categories/travel.svg',
    emojis: [
      {
        name: 'airplane arrival',
        url: 'https://media.fatsu.com/fatsoji/travel/Airplane Arrival.png',
      },
      {
        name: 'airplane departure',
        url: 'https://media.fatsu.com/fatsoji/travel/Airplane Departure.png',
      },
      {
        name: 'airplane seat',
        url: 'https://media.fatsu.com/fatsoji/travel/Airplane Seat.png',
      },
      {
        name: 'airplane',
        url: 'https://media.fatsu.com/fatsoji/travel/Airplane.png',
      },
      {
        name: 'anchor',
        url: 'https://media.fatsu.com/fatsoji/travel/Anchor.png',
      },
      {
        name: 'auto rickshaw',
        url: 'https://media.fatsu.com/fatsoji/travel/Auto Rickshaw.png',
      },
      {
        name: 'automobile',
        url: 'https://media.fatsu.com/fatsoji/travel/Automobile.png',
      },
      {
        name: 'bellhop bell',
        url: 'https://media.fatsu.com/fatsoji/travel/Bellhop Bell.png',
      },
      {
        name: 'bicycle',
        url: 'https://media.fatsu.com/fatsoji/travel/Bicycle.png',
      },
      {
        name: 'bullet train',
        url: 'https://media.fatsu.com/fatsoji/travel/Bullet Train.png',
      },
      {
        name: 'bus stop',
        url: 'https://media.fatsu.com/fatsoji/travel/Bus Stop.png',
      },
      {
        name: 'bus',
        url: 'https://media.fatsu.com/fatsoji/travel/Bus.png',
      },
      {
        name: 'cable car-1',
        url: 'https://media.fatsu.com/fatsoji/travel/Cable Car-1.png',
      },
      {
        name: 'cable car',
        url: 'https://media.fatsu.com/fatsoji/travel/Cable Car.png',
      },
      {
        name: 'car front',
        url: 'https://media.fatsu.com/fatsoji/travel/Car Front.png',
      },
      {
        name: 'construction barrier',
        url: 'https://media.fatsu.com/fatsoji/travel/Construction Barrier.png',
      },
      {
        name: 'cruise ship',
        url: 'https://media.fatsu.com/fatsoji/travel/Cruise Ship.png',
      },
      {
        name: 'delivery truck',
        url: 'https://media.fatsu.com/fatsoji/travel/Delivery Truck.png',
      },
      {
        name: 'delivery van',
        url: 'https://media.fatsu.com/fatsoji/travel/Delivery Van.png',
      },
      {
        name: 'ferry',
        url: 'https://media.fatsu.com/fatsoji/travel/Ferry.png',
      },
      {
        name: 'fire truck',
        url: 'https://media.fatsu.com/fatsoji/travel/Fire Truck.png',
      },
      {
        name: 'fuel pump',
        url: 'https://media.fatsu.com/fatsoji/travel/Fuel Pump.png',
      },
      {
        name: 'funicular',
        url: 'https://media.fatsu.com/fatsoji/travel/Funicular.png',
      },
      {
        name: 'golf cart',
        url: 'https://media.fatsu.com/fatsoji/travel/Golf Cart.png',
      },
      {
        name: 'gondola lift',
        url: 'https://media.fatsu.com/fatsoji/travel/Gondola Lift.png',
      },
      {
        name: 'helicopter',
        url: 'https://media.fatsu.com/fatsoji/travel/Helicopter.png',
      },
      {
        name: 'high-speed train',
        url: 'https://media.fatsu.com/fatsoji/travel/High-Speed Train.png',
      },
      {
        name: 'horizontal traffic light',
        url: 'https://media.fatsu.com/fatsoji/travel/Horizontal Traffic Light.png',
      },
      {
        name: 'kick scooter',
        url: 'https://media.fatsu.com/fatsoji/travel/Kick Scooter.png',
      },
      {
        name: 'light rail',
        url: 'https://media.fatsu.com/fatsoji/travel/Light Rail.png',
      },
      {
        name: 'luggage',
        url: 'https://media.fatsu.com/fatsoji/travel/Luggage.png',
      },
      {
        name: 'monorail',
        url: 'https://media.fatsu.com/fatsoji/travel/Monorail.png',
      },
      {
        name: 'motorboat',
        url: 'https://media.fatsu.com/fatsoji/travel/Motorboat.png',
      },
      {
        name: 'motorcycle',
        url: 'https://media.fatsu.com/fatsoji/travel/Motorcycle.png',
      },
      {
        name: 'motorized wheelchair',
        url: 'https://media.fatsu.com/fatsoji/travel/Motorized Wheelchair.png',
      },
      {
        name: 'motorway',
        url: 'https://media.fatsu.com/fatsoji/travel/Motorway.png',
      },
      {
        name: 'mountain railway',
        url: 'https://media.fatsu.com/fatsoji/travel/Mountain Railway.png',
      },
      {
        name: 'no entry sign',
        url: 'https://media.fatsu.com/fatsoji/travel/No Entry Sign.png',
      },
      {
        name: 'oil barrel',
        url: 'https://media.fatsu.com/fatsoji/travel/Oil Barrel.png',
      },
      {
        name: 'parachute',
        url: 'https://media.fatsu.com/fatsoji/travel/Parachute.png',
      },
      {
        name: 'pickup truck',
        url: 'https://media.fatsu.com/fatsoji/travel/Pickup Truck.png',
      },
      {
        name: 'police car (front)',
        url: 'https://media.fatsu.com/fatsoji/travel/Police Car (Front).png',
      },
      {
        name: 'police car',
        url: 'https://media.fatsu.com/fatsoji/travel/Police Car.png',
      },
      {
        name: 'race car',
        url: 'https://media.fatsu.com/fatsoji/travel/Race Car.png',
      },
      {
        name: 'railway tracks',
        url: 'https://media.fatsu.com/fatsoji/travel/Railway Tracks.png',
      },
      {
        name: 'raised hand',
        url: 'https://media.fatsu.com/fatsoji/travel/Raised Hand.png',
      },
      {
        name: 'rocket',
        url: 'https://media.fatsu.com/fatsoji/travel/Rocket.png',
      },
      {
        name: 'roller skate',
        url: 'https://media.fatsu.com/fatsoji/travel/Roller Skate.png',
      },
      {
        name: 'rowboat',
        url: 'https://media.fatsu.com/fatsoji/travel/Rowboat.png',
      },
      {
        name: 'suv',
        url: 'https://media.fatsu.com/fatsoji/travel/SUV.png',
      },
      {
        name: 'sailboat',
        url: 'https://media.fatsu.com/fatsoji/travel/Sailboat.png',
      },
      {
        name: 'satellite',
        url: 'https://media.fatsu.com/fatsoji/travel/Satellite.png',
      },
      {
        name: 'scooter',
        url: 'https://media.fatsu.com/fatsoji/travel/Scooter.png',
      },
      {
        name: 'shinkansen',
        url: 'https://media.fatsu.com/fatsoji/travel/Shinkansen.png',
      },
      {
        name: 'siren',
        url: 'https://media.fatsu.com/fatsoji/travel/Siren.png',
      },
      {
        name: 'skateboard',
        url: 'https://media.fatsu.com/fatsoji/travel/Skateboard.png',
      },
      {
        name: 'small airplane',
        url: 'https://media.fatsu.com/fatsoji/travel/Small Airplane.png',
      },
      {
        name: 'speedboat',
        url: 'https://media.fatsu.com/fatsoji/travel/Speedboat.png',
      },
      {
        name: 'steam locomotive',
        url: 'https://media.fatsu.com/fatsoji/travel/Steam Locomotive.png',
      },
      {
        name: 'subway tunnel',
        url: 'https://media.fatsu.com/fatsoji/travel/Subway Tunnel.png',
      },
      {
        name: 'taxi (front)',
        url: 'https://media.fatsu.com/fatsoji/travel/Taxi (Front).png',
      },
      {
        name: 'taxi',
        url: 'https://media.fatsu.com/fatsoji/travel/Taxi.png',
      },
      {
        name: 'tractor',
        url: 'https://media.fatsu.com/fatsoji/travel/Tractor.png',
      },
      {
        name: 'trailer truck',
        url: 'https://media.fatsu.com/fatsoji/travel/Trailer Truck.png',
      },
      {
        name: 'train station',
        url: 'https://media.fatsu.com/fatsoji/travel/Train Station.png',
      },
      {
        name: 'tram car',
        url: 'https://media.fatsu.com/fatsoji/travel/Tram Car.png',
      },
      {
        name: 'tram',
        url: 'https://media.fatsu.com/fatsoji/travel/Tram.png',
      },
      {
        name: 'trolleybus-1',
        url: 'https://media.fatsu.com/fatsoji/travel/Trolleybus-1.png',
      },
      {
        name: 'trolleybus',
        url: 'https://media.fatsu.com/fatsoji/travel/Trolleybus.png',
      },
      {
        name: 'ufo',
        url: 'https://media.fatsu.com/fatsoji/travel/UFO.png',
      },
      {
        name: 'vertical traffic light',
        url: 'https://media.fatsu.com/fatsoji/travel/Vertical Traffic Light.png',
      },
      {
        name: 'wheelchair',
        url: 'https://media.fatsu.com/fatsoji/travel/Wheelchair.png',
      },
      {
        name: 'yacht',
        url: 'https://media.fatsu.com/fatsoji/travel/Yacht.png',
      },
    ],
  },
  {
    category: 'utility',
    categoryIcon: 'https://media.fatsu.com/fatsoji/categories/utility.svg',
    emojis: [
      {
        name: 'alembic',
        url: 'https://media.fatsu.com/fatsoji/utility/Alembic.png',
      },
      {
        name: 'axe',
        url: 'https://media.fatsu.com/fatsoji/utility/Axe.png',
      },
      {
        name: 'balance scale',
        url: 'https://media.fatsu.com/fatsoji/utility/Balance Scale.png',
      },
      {
        name: 'briefcase',
        url: 'https://media.fatsu.com/fatsoji/utility/Briefcase.png',
      },
      {
        name: 'candle',
        url: 'https://media.fatsu.com/fatsoji/utility/Candle.png',
      },
      {
        name: 'clamp',
        url: 'https://media.fatsu.com/fatsoji/utility/Clamp.png',
      },
      {
        name: 'diya lamp',
        url: 'https://media.fatsu.com/fatsoji/utility/Diya Lamp.png',
      },
      {
        name: 'flashlight',
        url: 'https://media.fatsu.com/fatsoji/utility/Flashlight.png',
      },
      {
        name: 'gear',
        url: 'https://media.fatsu.com/fatsoji/utility/Gear.png',
      },
      {
        name: 'hammer and pick',
        url: 'https://media.fatsu.com/fatsoji/utility/Hammer and Pick.png',
      },
      {
        name: 'hammer and wrench',
        url: 'https://media.fatsu.com/fatsoji/utility/Hammer and Wrench.png',
      },
      {
        name: 'hammer',
        url: 'https://media.fatsu.com/fatsoji/utility/Hammer.png',
      },
      {
        name: 'hook',
        url: 'https://media.fatsu.com/fatsoji/utility/Hook.png',
      },
      {
        name: 'key',
        url: 'https://media.fatsu.com/fatsoji/utility/Key.png',
      },
      {
        name: 'ladder',
        url: 'https://media.fatsu.com/fatsoji/utility/Ladder.png',
      },
      {
        name: 'lantern',
        url: 'https://media.fatsu.com/fatsoji/utility/Lantern.png',
      },
      {
        name: 'light bulb',
        url: 'https://media.fatsu.com/fatsoji/utility/Light Bulb.png',
      },
      {
        name: 'link',
        url: 'https://media.fatsu.com/fatsoji/utility/Link.png',
      },
      {
        name: 'locked with key',
        url: 'https://media.fatsu.com/fatsoji/utility/Locked with Key.png',
      },
      {
        name: 'locked with pen',
        url: 'https://media.fatsu.com/fatsoji/utility/Locked with Pen.png',
      },
      {
        name: 'locked',
        url: 'https://media.fatsu.com/fatsoji/utility/Locked.png',
      },
      {
        name: 'magnet',
        url: 'https://media.fatsu.com/fatsoji/utility/Magnet.png',
      },
      {
        name: 'needle and thread',
        url: 'https://media.fatsu.com/fatsoji/utility/Needle and Thread.png',
      },
      {
        name: 'old key',
        url: 'https://media.fatsu.com/fatsoji/utility/Old Key.png',
      },
      {
        name: 'pick',
        url: 'https://media.fatsu.com/fatsoji/utility/Pick.png',
      },
      {
        name: 'saw',
        url: 'https://media.fatsu.com/fatsoji/utility/Saw.png',
      },
      {
        name: 'screwdriver',
        url: 'https://media.fatsu.com/fatsoji/utility/Screwdriver.png',
      },
      {
        name: 'spool of thread',
        url: 'https://media.fatsu.com/fatsoji/utility/Spool of Thread.png',
      },
      {
        name: 'thread knot',
        url: 'https://media.fatsu.com/fatsoji/utility/Thread Knot.png',
      },
      {
        name: 'unlocked',
        url: 'https://media.fatsu.com/fatsoji/utility/Unlocked.png',
      },
      {
        name: 'wrench-1',
        url: 'https://media.fatsu.com/fatsoji/utility/Wrench-1.png',
      },
      {
        name: 'wrench',
        url: 'https://media.fatsu.com/fatsoji/utility/Wrench.png',
      },
      {
        name: 'yarn ball',
        url: 'https://media.fatsu.com/fatsoji/utility/Yarn Ball.png',
      },
    ],
  },
  {
    category: 'weather',
    categoryIcon: 'https://media.fatsu.com/fatsoji/categories/weather.svg',
    emojis: [
      {
        name: 'alarm clock',
        url: 'https://media.fatsu.com/fatsoji/weather/Alarm Clock.png',
      },
      {
        name: 'beach umbrella',
        url: 'https://media.fatsu.com/fatsoji/weather/Beach Umbrella.png',
      },
      {
        name: 'bridge',
        url: 'https://media.fatsu.com/fatsoji/weather/Bridge.png',
      },
      {
        name: 'city skyline',
        url: 'https://media.fatsu.com/fatsoji/weather/City Skyline.png',
      },
      {
        name: 'closed umbrella',
        url: 'https://media.fatsu.com/fatsoji/weather/Closed Umbrella.png',
      },
      {
        name: 'cloud crescent',
        url: 'https://media.fatsu.com/fatsoji/weather/Cloud Crescent.png',
      },
      {
        name: 'cloud stars',
        url: 'https://media.fatsu.com/fatsoji/weather/Cloud Stars.png',
      },
      {
        name: 'cloud sun',
        url: 'https://media.fatsu.com/fatsoji/weather/Cloud Sun.png',
      },
      {
        name: 'cloud-1',
        url: 'https://media.fatsu.com/fatsoji/weather/Cloud-1.png',
      },
      {
        name: 'cloud',
        url: 'https://media.fatsu.com/fatsoji/weather/Cloud.png',
      },
      {
        name: 'cloudy sky',
        url: 'https://media.fatsu.com/fatsoji/weather/Cloudy Sky.png',
      },
      {
        name: 'crescent moon',
        url: 'https://media.fatsu.com/fatsoji/weather/Crescent Moon.png',
      },
      {
        name: 'desk clock',
        url: 'https://media.fatsu.com/fatsoji/weather/Desk Clock.png',
      },
      {
        name: 'folded umbrella',
        url: 'https://media.fatsu.com/fatsoji/weather/Folded Umbrella.png',
      },
      {
        name: 'full moon',
        url: 'https://media.fatsu.com/fatsoji/weather/Full Moon.png',
      },
      {
        name: 'glitter moon',
        url: 'https://media.fatsu.com/fatsoji/weather/Glitter Moon.png',
      },
      {
        name: 'glitter star',
        url: 'https://media.fatsu.com/fatsoji/weather/Glitter Star.png',
      },
      {
        name: 'glitter sun',
        url: 'https://media.fatsu.com/fatsoji/weather/Glitter Sun.png',
      },
      {
        name: 'grid cloud',
        url: 'https://media.fatsu.com/fatsoji/weather/Grid Cloud.png',
      },
      {
        name: 'half moon',
        url: 'https://media.fatsu.com/fatsoji/weather/Half Moon.png',
      },
      {
        name: 'hanging stars',
        url: 'https://media.fatsu.com/fatsoji/weather/Hanging Stars.png',
      },
      {
        name: 'hot springs',
        url: 'https://media.fatsu.com/fatsoji/weather/Hot Springs.png',
      },
      {
        name: 'hourglass',
        url: 'https://media.fatsu.com/fatsoji/weather/Hourglass.png',
      },
      {
        name: 'iceberg',
        url: 'https://media.fatsu.com/fatsoji/weather/Iceberg.png',
      },
      {
        name: 'kite     glitter moon',
        url: 'https://media.fatsu.com/fatsoji/weather/Kite     Glitter Moon.png',
      },
      {
        name: 'kite',
        url: 'https://media.fatsu.com/fatsoji/weather/Kite.png',
      },
      {
        name: 'lightning bolt',
        url: 'https://media.fatsu.com/fatsoji/weather/Lightning Bolt.png',
      },
      {
        name: 'lightning cloud',
        url: 'https://media.fatsu.com/fatsoji/weather/Lightning Cloud.png',
      },
      {
        name: 'lunar slice',
        url: 'https://media.fatsu.com/fatsoji/weather/Lunar Slice.png',
      },
      {
        name: 'mailbox',
        url: 'https://media.fatsu.com/fatsoji/weather/Mailbox.png',
      },
      {
        name: 'moonlight',
        url: 'https://media.fatsu.com/fatsoji/weather/Moonlight.png',
      },
      {
        name: 'moonlit cityscape',
        url: 'https://media.fatsu.com/fatsoji/weather/Moonlit Cityscape.png',
      },
      {
        name: 'mountain view',
        url: 'https://media.fatsu.com/fatsoji/weather/Mountain View.png',
      },
      {
        name: 'night cityscape',
        url: 'https://media.fatsu.com/fatsoji/weather/Night Cityscape.png',
      },
      {
        name: 'open umbrella',
        url: 'https://media.fatsu.com/fatsoji/weather/Open Umbrella.png',
      },
      {
        name: 'rain cloud with sun',
        url: 'https://media.fatsu.com/fatsoji/weather/Rain Cloud with Sun.png',
      },
      {
        name: 'rain cloud-1',
        url: 'https://media.fatsu.com/fatsoji/weather/Rain Cloud-1.png',
      },
      {
        name: 'rain cloud-2',
        url: 'https://media.fatsu.com/fatsoji/weather/Rain Cloud-2.png',
      },
      {
        name: 'rain cloud',
        url: 'https://media.fatsu.com/fatsoji/weather/Rain Cloud.png',
      },
      {
        name: 'rainbow cloud',
        url: 'https://media.fatsu.com/fatsoji/weather/Rainbow Cloud.png',
      },
      {
        name: 'rainbow',
        url: 'https://media.fatsu.com/fatsoji/weather/Rainbow.png',
      },
      {
        name: 'river',
        url: 'https://media.fatsu.com/fatsoji/weather/River.png',
      },
      {
        name: 'sand timer',
        url: 'https://media.fatsu.com/fatsoji/weather/Sand Timer.png',
      },
      {
        name: 'saturn',
        url: 'https://media.fatsu.com/fatsoji/weather/Saturn.png',
      },
      {
        name: 'shooting star-1',
        url: 'https://media.fatsu.com/fatsoji/weather/Shooting Star-1.png',
      },
      {
        name: 'shooting star',
        url: 'https://media.fatsu.com/fatsoji/weather/Shooting Star.png',
      },
      {
        name: 'smiley moon',
        url: 'https://media.fatsu.com/fatsoji/weather/Smiley Moon.png',
      },
      {
        name: 'smiley sun',
        url: 'https://media.fatsu.com/fatsoji/weather/Smiley Sun.png',
      },
      {
        name: 'spark thermometer',
        url: 'https://media.fatsu.com/fatsoji/weather/Spark Thermometer.png',
      },
      {
        name: 'spiky cloud',
        url: 'https://media.fatsu.com/fatsoji/weather/Spiky Cloud.png',
      },
      {
        name: 'star globe',
        url: 'https://media.fatsu.com/fatsoji/weather/Star Globe.png',
      },
      {
        name: 'starry',
        url: 'https://media.fatsu.com/fatsoji/weather/Starry.png',
      },
      {
        name: 'stopwatch',
        url: 'https://media.fatsu.com/fatsoji/weather/Stopwatch.png',
      },
      {
        name: 'storm cloud',
        url: 'https://media.fatsu.com/fatsoji/weather/Storm Cloud.png',
      },
      {
        name: 'sunburst',
        url: 'https://media.fatsu.com/fatsoji/weather/Sunburst.png',
      },
      {
        name: 'sunrise',
        url: 'https://media.fatsu.com/fatsoji/weather/Sunrise.png',
      },
      {
        name: 'sunset scene',
        url: 'https://media.fatsu.com/fatsoji/weather/Sunset Scene.png',
      },
      {
        name: 'sunshine',
        url: 'https://media.fatsu.com/fatsoji/weather/Sunshine.png',
      },
      {
        name: 'thermometer',
        url: 'https://media.fatsu.com/fatsoji/weather/Thermometer.png',
      },
      {
        name: 'timer',
        url: 'https://media.fatsu.com/fatsoji/weather/Timer.png',
      },
      {
        name: 'tornado',
        url: 'https://media.fatsu.com/fatsoji/weather/Tornado.png',
      },
      {
        name: 'umbrella with raindrops',
        url: 'https://media.fatsu.com/fatsoji/weather/Umbrella with Raindrops.png',
      },
      {
        name: 'urban buildings',
        url: 'https://media.fatsu.com/fatsoji/weather/Urban Buildings.png',
      },
      {
        name: 'wavy path',
        url: 'https://media.fatsu.com/fatsoji/weather/Wavy Path.png',
      },
      {
        name: 'wristwatch',
        url: 'https://media.fatsu.com/fatsoji/weather/Wristwatch.png',
      },
    ],
  },
];
